<template>
  <div ref="spot">
    <div v-if="storeState.noAccess" class="tw-pt-48 tw-px-48">
      <div class="tw-text-left tw-px-16 tw-py-16 tw-text-xl tw-font-bold tw-shadow-xl">
        <h4> You don't have access to this block 😢, contact your team admin to get it or 
          <button @click="newBlock" class="btn-link"> create your own block here</button>
          <br><br>
          <button @click="store.getHelp" class="btn-link"> Click here to get help.</button>
        </h4>
      </div>
    </div>
    <div v-else-if="!storeState.gotBlock" class="tw-flex tw-justify-center">
      <div class="tw-pt-32">
        <v-progress-circular
          indeterminate
          :size="100"
          :width="8"
          color="primary"
        >
        </v-progress-circular>
      </div>
    </div>
    <div v-else-if="storeState.gotBlock">
      <div>
        <!-- SOURCE -->
        <!-- DESTINATION -->
        <div v-if="fromTse && fromTse.columnsAndData">
          <!-- {{fromTse.columnsAndData.columns.map(c => c.column.name)}} -->
        </div>
        <div
          v-if="!editDestination && (['sql', 'story', 'sheetsAsSql', 'airtableAsSql', 'python'].includes(storeState.block.cellType))" 
          no-gutters class="" 
          @mouseover="hoverDestination=true" 
          @mouseleave="hoverDestination=false"
        >
          <div class="">
            <div @click="showDestination=true" class="">
              <v-icon small class="dest-type-icon">mdi-arrow-right</v-icon>
              <div class="tw-font-bold tw-inline tw-ml-6">Destination</div>
              <div 
                v-if="(hoverDestination || pauseDestination) && storeState.block.destination.type != 'sheets'" 
                class="tw-inline-block tw-float-right"
              >
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button 
                      @click="pauseDestination = !pauseDestination"
                      v-on="on" 
                      class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                      @mouseenter="actionBtns.pauseDestination = true"
                      @mouseleave="actionBtns.pauseDestination = false"
                    >
                      <v-icon :color="(actionBtns.pauseDestination ||  pauseDestination)? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-pause</v-icon>
                    </button>
                  </template>
                  <span class="tooltip-text">{{`${pauseDestination ? 'Resume' : 'Pause'} sending to destination`}}</span>
                </v-tooltip>
              </div>
              <div 
                v-else-if="hoverDestination && storeState.block.destination.type === 'sheets' && storeState.block.destination.ss_id" 
                class="tw-inline-block tw-float-right"
              >
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button 
                      @click="openSheet"
                      v-on="on" 
                      class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                      @mouseenter="actionBtns.openSheet = true"
                      @mouseleave="actionBtns.openSheet = false"
                    >
                      <v-icon :color="actionBtns.openSheet ? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-open-in-new</v-icon>
                    </button>
                  </template>
                  <span class="tooltip-text">Open Sheet</span>
                </v-tooltip>
              </div>
              <div 
                v-if="hoverDestination && 
                      storeState.block.destination.type === 'block' && 
                      storeState.block.destination.block &&
                      storeState.block.destination.block.uuid" 
                class="tw-inline-block tw-float-right"
              >
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button 
                      @click="newWindow(storeState.block.destination.block.uuid)"
                      v-on="on" 
                      class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                      @mouseenter="actionBtns.openSheet = true"
                      @mouseleave="actionBtns.openSheet = false"
                    >
                      <v-icon :color="actionBtns.openSheet ? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-open-in-new</v-icon>
                    </button>
                  </template>
                  <span class="tooltip-text">Open block</span>
                </v-tooltip>
              </div>
            </div>
          </div>
          <div @click="editDestination = true" class="tw-cursor-pointer tw-inline-block tw-ml-9 tw-mt-2 tw-p-1 hover:tw-font-bold tw-rounded">
            <span class="" v-html="store.getDestinationSummary(storeState.block)"></span>
          </div>
        </div>
        <div v-if="editDestination" class="">
          <div class="">
            <div @click="showDestination=true" class="">
              <v-icon small class="dest-type-icon">mdi-arrow-right</v-icon>
              <div class="tw-font-bold tw-inline tw-ml-6">Destination</div>
            </div>
          </div>
          <div class="tw-inline-block tw-ml-9 tw-mt-2 tw-pl-1 hover:tw-font-bold tw-rounded">
            <v-select
              v-model="storeState.block.destination.type"
              :items="storeState.destinationTypes.filter(o => (storeState.block.cellType === 'story' && o.story) || storeState.block.cellType != 'story')"
              label=""
              dense
              class="denser"
            > 
              <template v-slot:selection="data">
                <div :data-type="data.item.value" class="tw-cursor-pointer">
                  <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                  <span class="tw-pl-0">{{data.item.text}}</span>
                </div>
              </template>
              <template v-slot:item="data">
                <div :data-type="data.item.value" class="tw-cursor-pointer">
                  <v-icon small>{{data.item.icon}}</v-icon>
                  <span class="tw-pl-2">{{data.item.text}}</span>
                </div>
              </template>
            </v-select>
          </div>
          <div class="tw-ml-10 tw-mt-0">
            <!-- DATABASE DESTINATION -->
            <div v-if="storeState.block.destination.type === 'database'">
              <v-select
                :items="databaseOperations"
                v-model="storeState.block.destination.database.operation"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Operation"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'database'">
              <v-autocomplete
                v-model="storeState.block.destination.database.uuid"
                :items="dbDestinations"
                placeholder="Database"
                item-text="name"
                item-value="block_uuid"
                auto-select-first
                single-line
                dense
                autocomplete="disabled"
                class="denser"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <!-- {{item.name}} -->
                    <v-list-item-title v-html="item.name">{{item}}</v-list-item-title>
                    <v-list-item-subtitle v-html="item.db_type"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:no-data>
                  <div></div>
                </template>
                <template v-slot:append-item>
                  <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="addSource">
                    Add database
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'database'">
              <v-text-field
                v-model="storeState.block.destination.database.table"
                placeholder="table (schema.table)"
                single-line
                dense
                autocomplete="off"
                class="denser tw-inline-block"
              >
              </v-text-field>
            </div>
            <!-- END DATABASE DESTINATION -->
            <!-- MANUAL -->
            <div class="" v-if="storeState.block.destination.type === 'manual'">
              <!-- <textarea name="" id="" cols="30" rows="10"></textarea> -->
              <div class="tw-border tw-rounded-sm">
                <codemirror 
                  @input="onManualCmChange"
                  :options="cmManualOptions"
                  :value="storeState.block.manualDestination"
                  style="height: 300px;"
                  ref="manualCm"
                >
                </codemirror>  
              </div>
              <div v-if="manualDestinationError" class="tw-text-red-600">
                {{manualDestinationError}}
              </div>
              <div class="tw-mt-4 tw-mb-2">
                <a
                  href="https://doc.seekwell.io/ded91c1918c44b2cba5d44a1131fdea1"
                  target="_blank"
                >
                  Click here for help
                </a>
              </div>
            </div>
            <!-- END MANUAL -->
            <!-- HUBSPOT -->
            <div v-if="storeState.block.destination.type === 'hubspot' && !storeState.integrations.hubspot">
              <a href="https://app.seekwell.io/integrations" target="_blank">You need to authorize Hubspot</a>
            </div>
            <div v-if="storeState.block.destination.type === 'hubspot' && storeState.integrations.hubspot">
              <v-select
                :items="hubspotObjects"
                v-model="storeState.block.destination.hubspot.obj"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Object"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'hubspot' && storeState.integrations.hubspot">
              <v-select
                :items="hubspotOperations"
                v-model="storeState.block.destination.hubspot.operation"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Key"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <!-- END HUBSPOT -->
            <!-- SERVICENOW -->
            <div v-if="storeState.block.destination.type === 'servicenow' && !storeState.integrations.servicenow">
              <a href="http://localhost:8081/profile?ref=servicenow" target="_blank">You need to authorize ServiceNow</a>
            </div>
            <div v-if="storeState.block.destination.type === 'servicenow' && storeState.integrations.servicenow">
              <v-select
                :items="servicenowObjects"
                v-model="storeState.block.destination.servicenow.obj"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Object"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'servicenow' && storeState.integrations.servicenow">
              <v-select
                :items="servicenowOperations"
                v-model="storeState.block.destination.servicenow.operation"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Key"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <!-- END SERVICENOW -->
             <!-- MAILCHIMP -->
            <div v-if="storeState.block.destination.type === 'mailchimp' && !storeState.integrations.mailchimp">
              <a href="https://login.mailchimp.com/oauth2/authorize?client_id=177755327963&redirect_uri=https://seekwell.io/mailchimp2&response_type=code&state=test" target="_blank">You need to authorize Mailchimp</a>
            </div>
            <div v-if="storeState.block.destination.type === 'mailchimp' && storeState.integrations.mailchimp">
              <v-select
                :items="mailchimpObjects"
                v-model="storeState.block.destination.mailchimp.obj"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Object"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'mailchimp' && storeState.integrations.mailchimp">
              <v-select
                :items="mailchimpOperations"
                v-model="storeState.block.destination.mailchimp.operation"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Key"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <!-- END MAILCHIMP -->

            <!-- GAINSIGHT -->
            <div v-if="storeState.block.destination.type === 'gainsight' && !storeState.integrations.gainsight">
              <a href="http://localhost:8081/profile?ref=gainsight" target="_blank">You need to authorize Gainsight</a>
            </div>
            <div v-if="storeState.block.destination.type === 'gainsight' && storeState.integrations.gainsight">
              <v-select
                :items="gainsightObjects"
                v-model="storeState.block.destination.gainsight.obj"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Object"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'gainsight' && storeState.integrations.gainsight">
              <v-select
                :items="gainsightOperations"
                v-model="storeState.block.destination.gainsight.operation"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Key"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <!-- END GAINSIGHT -->

            <!-- ZENDESK -->
            <div v-if="storeState.block.destination.type === 'zendesk' && !storeState.integrations.zendesk">
              <a href="https://app.seekwell.io/integrations" target="_blank">You need to authorize Zendesk</a>
            </div>
            <div v-if="storeState.block.destination.type === 'zendesk' && storeState.integrations.zendesk">
              <v-select
                :items="zendeskObjects"
                v-model="storeState.block.destination.zendesk.obj"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Type"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'zendesk' && storeState.integrations.zendesk">
              <v-select
                :items="zendeskKeyTypes"
                v-model="storeState.block.destination.zendesk.key"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Type"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'zendesk' && storeState.integrations.zendesk">
              <v-select
                :items="zendeskEndpoints"
                v-model="storeState.block.destination.zendesk.endpoint"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Type"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <!-- END ZENDESK -->
            <!-- SFDC -->
            <div v-if="storeState.block.destination.type === 'sfdc' && !storeState.gotSfdc">
              <a href="https://app.seekwell.io/integrations" target="_blank">You need to authorize Salesforce</a>
            </div>
            <div v-if="storeState.block.destination.type === 'sfdc' && storeState.gotSfdc">
              <v-autocomplete
                v-model="storeState.block.destination.sfdc.object"
                :items="storeState.destinations.sfdc.objects.sobjects"
                placeholder="Object"
                item-text="name"
                auto-select-first
                return-object
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <div></div>
                </template>
                <template v-slot:append-item>
                  <div v-if="storeState.gettingSfdc" class="tw-flex tw-justify-center">
                    <div class="tw-py-2">
                      <v-progress-circular
                        indeterminate
                        :size="30"
                        :width="4"
                        color="primary"
                      >
                      </v-progress-circular>
                    </div>
                  </div>
                  <div v-else>
                    <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="gettingSfdc=true">
                      <div>Refresh Salesforce model</div>
                    </div>
                  </div>
                </template>
              </v-autocomplete>
              <v-select
                :items="sfdcOperations"
                v-model="storeState.block.destination.sfdc.operation"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Operation"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
              <div v-if="storeState.block.destination.sfdc.operation === 'upsert'" class="tw-inline-block">
                <v-autocomplete
                  v-if="fromTse && fromTse.columnsAndData"
                  v-model="storeState.block.destination.sfdc.externalId"
                  :items="fromTse.columnsAndData.columns.map(c => c.column)"
                  placeholder="Map column"
                  item-text="name"
                  item-value="name"
                  return-value="name"
                  :rules="[fieldRules.required]"
                  required
                  auto-select-first
                  single-line
                  dense
                  autocomplete="off"
                  class="denser"
                >
                  <!-- <template v-slot:selection="data">
                    <div class="tw-cursor-pointer">
                      <span class="tw-pl-0">{{data.item.name}}</span>
                    </div>
                  </template> -->
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        <v-btn @click="refreshTse" text>Refresh</v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                      <div>
                        {{item.name}}
                      </div>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-model="storeState.block.destination.sfdc.mapToExternalId"
                  :items="storeState.sfdcMetadata[storeState.block.destination.sfdc.object.name].filter(f => true)"
                  placeholder="To External ID"
                  item-text="name"
                  item-value="id"
                  :rules="[fieldRules.required]"
                  required
                  auto-select-first
                  single-line
                  dense
                  autocomplete="off"
                  class="denser"
                >
                  <!-- <template v-slot:selection="data">
                    <div class="tw-cursor-pointer">
                      <span class="tw-pl-0">{{data.item.name}}</span>
                    </div>
                  </template> -->
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        <v-btn @click="refreshTse" text>Refresh</v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                      <div>
                        {{item.name}}
                      </div>
                  </template>
                </v-autocomplete>

              </div>
            </div>
            <!-- END SFDC -->
            <!-- INTERCOM -->
            <div v-if="storeState.block.destination.type === 'intercom' && !storeState.gotIntercom">
              <a href="https://app.seekwell.io/integrations" target="_blank">You need to authorize Intercom</a>
            </div>
            <div v-if="storeState.block.destination.type === 'intercom' && storeState.gotIntercom">
              <v-select
                :items="intercomRoleTypes"
                v-model="storeState.block.destination.intercom.role"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Type"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'intercom' && storeState.gotIntercom">
              <v-select
                :items="intercomKeyTypes"
                v-model="storeState.block.destination.intercom.key"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Type"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <!-- END INTERCOM -->
            <!-- EXCEL -->
            <div v-if="storeState.block.destination.type === 'excel' && 
                        !storeState.gotWorkbooks && storeState.block.destination.excelLocation ==='onedrive'">
              <a href="http://seekwell.io/O365_login" target="_blank">You need to authorize Excel</a>
            </div>
            <div v-if="storeState.block.destination.type === 'excel' && storeState.gotWorkbooks" class="tw-py-0">
              <v-select
                v-model="storeState.block.excelLocation"
                :items="storeState.excelLocations"
                item-text="text"
                item-value="value"
                label=""
                dense
                class="denser"
              > 
                <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <span class="tw-pl-0">{{data.item.text}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.text}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'excel' && storeState.gotWorkbooks 
                        && storeState.block.destination.excelLocation ==='googledrive'" class="tw-py-0">
              <v-autocomplete
                v-model="storeState.block.destination.gdWorkbookId"
                :items="storeState.destinations.gdWorkbooks"
                :search-input.sync="searchGdWorkbook"
                placeholder="Workbook"
                item-text="name"
                item-value="id"
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <div></div>
                </template>
                <template v-slot:append-item>
                  <div v-if="loadingWorkbooks" class="tw-flex tw-justify-center">
                    <div class="tw-py-2">
                      <v-progress-circular
                        indeterminate
                        :size="30"
                        :width="4"
                        color="primary"
                      >
                      </v-progress-circular>
                    </div>
                  </div>
                  <div v-else>
                    <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="refreshGdWorkbooks">
                      <div>Refresh Sheets</div>
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'excel' && storeState.gotWorkbooks 
                        && storeState.block.destination.excelLocation ==='onedrive'" class="tw-py-0">
              <v-autocomplete
                ref="workbooks"
                v-model="storeState.block.destination.workbookId"
                :items="storeState.destinations.workbooks"
                :search-input.sync="searchWorkbook"
                placeholder="Workbook"
                item-text="name"
                item-value="id"
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <div></div>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'excel' && storeState.gotWorkbooks" class="tw-inline-block">
              <v-text-field
                v-model="storeState.block.destination.excelSheetName"
                placeholder="Sheet1"
                single-line
                dense
                autocomplete="off"
                class="denser tw-inline-block"
              >
              </v-text-field>
            </div>
            <div v-if="storeState.block.destination.type === 'excel' && storeState.gotWorkbooks" class="tw-inline-block">
              <v-text-field
                v-model="storeState.block.destination.excelCell"
                placeholder="A1"
                single-line
                dense
                autocomplete="off"
                class="denser tw-inline-block"
              >
              </v-text-field>
            </div>
            <!-- END EXCEL -->
            <!-- START BLOCK DEST -->
            <div v-if="(storeState.block.destination.type === 'block')"  class="">
              <v-select
                v-model="storeState.block.destination.destinationBlockType"
                :items="destinationBlockTypes"
                item-text="label"
                item-value="key"
                label=""
                required
                placeholder="Type"
                dense
                class="denser"
              >
              <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                    <span class="tw-pl-0">{{data.item.label}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.label}}</span>
                  </div>
                </template>
              </v-select>
              <v-autocomplete
                v-model="storeState.block.destination.block"
                :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                placeholder="Block"
                item-text="title"
                item-value="uuid"
                return-object
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:append-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <!-- END BLOCK DEST -->
            <!-- START SHEETS -->
            <div v-if="storeState.block.destination.type === 'sheets' && !storeState.gotSheets">
              <a class="sw-blue" href="https://seekwell.io/web_auth_sheets" target="_blank">Click here to authorize</a>
            </div>
            <div v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" class="tw-py-0">
              <v-autocomplete
                ref="spreadSheets"
                v-model="storeState.block.destination.ss_id"
                :items="storeState.destinations.spreadSheets"
                :search-input.sync="searchSpreadsheet"
                placeholder="Spreadsheet"
                item-text="name"
                item-value="id"
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
                @change="onSpreadSheetChange"
              >
                <template v-slot:no-data>
                  <div></div>
                </template>
                <template v-slot:append-item>
                  <div v-if="loadingSpreadsheets" class="tw-flex tw-justify-center">
                    <div class="tw-py-2">
                      <v-progress-circular
                        indeterminate
                        :size="30"
                        :width="4"
                        color="primary"
                      >
                      </v-progress-circular>
                    </div>
                  </div>
                  <div v-else>
                    <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="refreshSpreadSheets">
                      <div>Refresh Sheets</div>
                    </div>
                    <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="newSpreadsheet">
                      Create new Sheet
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" class="tw-py-2">
              <v-autocomplete
                ref="sheet"
                v-model="storeState.block.destination.sheet"
                :items="storeState.destinations.sheets"
                :search-input.sync="searchSheet"
                placeholder="Sheet1"
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
                :loading="loadingSheets"
              >
                <template v-slot:no-data>
                  <v-list-item v-if="loadingSheets">
                    <v-list-item-title>
                      <v-progress-circular
                        indeterminate
                        :size="20"
                        :width="5"
                        color="primary"
                        class="justify-center align-center"
                      > 
                      </v-progress-circular> Loading
                    </v-list-item-title>
                  </v-list-item>
                  <div v-else></div>
                </template>
                <template v-slot:append-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn @click="addSheet" text>"<strong>{{ searchSheet }}</strong>" does not exist, add it?</v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" class="tw-inline-block">
              <v-text-field
                v-model="storeState.block.destination.cell"
                placeholder="A1"
                single-line
                dense
                autocomplete="off"
                class="denser tw-inline-block"
              >
              </v-text-field>
            </div>
            <div v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" class="tw-inline-block tw-pt-2">
              <v-select
                v-model="appendReplace"
                :items="storeState.appendTypes"
                label=""
                dense
                class="denser"
              > 
                <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <span class="tw-pl-0">{{data.item.text}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.text}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" class="tw-inline-block tw-pt-2">
              <v-select
                v-model="storeState.block.destination.omitColumnNames"
                :items="storeState.omitTypes"
                label=""
                dense
                class="denser"
              > 
                <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <span class="tw-pl-0">{{data.item.text}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.text}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-if="storeState.block.destination.type === 'slack'" class="">
              <v-autocomplete
                ref="spreadSheets"
                v-model="storeState.block.destination.channel"
                :items="storeState.destinations.slack.channels.channels"
                placeholder="Channel"
                item-text="name"
                item-value="name"
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn text>Loading</v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'email'" class="">
              <v-autocomplete
                v-model="storeState.block.destination.emailOverrideSender"
                :items="getSenders"
                return-object
                item-text="email"
                item-value="email"
                label=""
                placeholder="Send from"
                dense
                class="denser"
                autocomplete="off"
                auto-select-first
                single-line
              > 
                <template v-slot:selection="data">
                  <div :data-email="data.item.email" class="tw-cursor-pointer">
                    <span class="tw-pl-0">{{data.item.email}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.email" class="tw-cursor-pointer tw-w-full">
                    <img class="tw-rounded-full tw-h-4 tw-mt-1 tw-float-left" :src="getUserPic(data.item.email)">
                    <span class="tw-pl-3">{{data.item.email}}</span>
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'email'" class="">
              <v-select
                v-model="storeState.block.destination.emailSource"
                :items="storeState.emailSourceTypes"
                label=""
                dense
                class="denser"
              > 
                <template v-slot:selection="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <span class="tw-pl-0">{{data.item.text}}</span>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div :data-type="data.item.value" class="tw-cursor-pointer">
                    <v-icon small>{{data.item.icon}}</v-icon>
                    <span class="tw-pl-2">{{data.item.text}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            
            <div v-if="(storeState.block.destination.type === 'email' && 
                        storeState.block.destination.emailSource && storeState.block.destination.emailSource === 'block')"  class="">
              <v-autocomplete
                v-model="storeState.block.destination.emailSourceBlock"
                :items="blockList"
                placeholder="Block"
                item-text="title"
                item-value="uuid"
                return-object
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:append-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="(storeState.block.destination.type === 'email' && 
                        storeState.block.destination.emailSource && 
                        storeState.block.destination.emailSource === 'block' && 
                        storeState.block.destination.emailSourceBlock &&
                        storeState.block.destination.emailSourceBlock.uuid)"  class="">
              <v-autocomplete
                v-model="storeState.block.destination.emailSourceColumn"
                :items="destinationListBlockHeaders"
                placeholder="Email column"
                item-text="text"
                item-value="value"
                auto-select-first
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <div v-else-if="storeState.block.destination.type === 'email'" class="">
              <v-text-field
                ref="emails"
                v-model="storeState.block.destination.emails"
                placeholder="Emails (comma separated list)"
                single-line
                dense
                autocomplete="newpassword"
                class="denser"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn text>Loading</v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-text-field>
            </div>
            <div v-if="storeState.block.destination.type === 'sync'" class="">
              <v-autocomplete
                ref="table"
                v-model="storeState.block.destination.table"
                :items="dbTables"
                :search-input.sync="searchTable"
                placeholder="Table"
                item-text="name"
                item-value="name"
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title v-if="!loadingMeta">
                      <v-btn @click="addTable" text>"<strong>{{ searchTable }}</strong>" not found, refresh database?</v-btn>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <v-progress-circular
                        indeterminate
                        :size="20"
                        :width="5"
                        color="primary"
                        class="justify-center align-center"
                      > 
                      </v-progress-circular> Loading
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'sync'">
              <v-autocomplete
                ref="table"
                v-model="storeState.block.destination.primaryKey"
                :items="dbPrimaryKeys"
                :search-input.sync="searchPrimaryKey"
                placeholder="Primary Key"
                item-text="name"
                item-value="name"
                single-line
                dense
                autocomplete="off"
                class="denser"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title v-if="!loadingMeta">
                      <span>"<strong>{{ searchPrimaryKey }}</strong>" does not exist</span>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <v-progress-circular
                        indeterminate
                        :size="20"
                        :width="5"
                        color="primary"
                        class="justify-center align-center"
                      > 
                      </v-progress-circular> Loading
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="storeState.block.destination.type === 'sync'">
              <v-checkbox
                v-model="storeState.block.destination.isAutoIncrement"
                label="Auto"
                dense
                small
                class="denser" 
              ></v-checkbox>
            </div>
            <div class="tw-pt-1 tw-mb-12">
              <button @click="editDestination = false" class="hover:tw-bg-gray-300 tw-font-bold tw-p-1 tw-rounded">
                Save
              </button>
              <button @click="clearDestination" class="tw-ml-8 hover:tw-bg-gray-300 tw-font-bold tw-p-1 tw-rounded">
                Clear
              </button>
            </div>
          </div>
        </div>


        <!-- TAGSSSSSSSSSSS -->

        <div v-if="(!editParams)" no-gutters class="tw-mt-8">
          <div 
            @mouseover="hoverParams=true" 
            @mouseleave="hoverParams=false"
          >
            <div 
              class=""
              
            >
              <v-icon small class="">mdi-tune</v-icon>
              <div class="tw-font-bold tw-inline tw-ml-6">Parameters</div>
              <div 
                v-if="hoverParams" 
                class="tw--mt-8 tw-absolute tw-mr-8 tw-right-0"
              >
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button 
                      @click="openForm"
                      v-on="on" 
                      class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                      @mouseenter="actionBtns.openForm = true"
                      @mouseleave="actionBtns.openForm = false"
                    >
                      <v-icon :color="actionBtns.openForm ? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-open-in-new</v-icon>
                    </button>
                  </template>
                  <span class="tooltip-text">Open Form</span>
                </v-tooltip>
              </div>
            </div>
          </div>
          <div class="tw-inline-block tw-ml-9 tw-mt-3 tw-w-full">
            <div>
              <div class="tw-pb-4"
                v-for="(item, index) in storeState.block.params"
                :key="index"
              >
                <div 
                  @click="editParams=true" 
                  class="tw-cursor-pointer tw-inline-block tw-p-1 hover:tw-font-bold tw-rounded"
                >
                  {{item.type}} -> {{item.name}} 
                  <span v-if="item.value">-> {{item.value}}</span>
                </div>
              </div>
            </div>
          </div>
          <div @click="addParameter" class="tw-ml-9 tw-mt-2 hover:tw-font-bold tw-cursor-pointer">
            <div>
              <div class="tw-p-1">
                Add parameter
              </div>
            </div>
          </div>
        </div>
        <div v-if="(storeState.block.params && storeState.block.params.length > 0 && editParams) ||
                      (storeState.block.cellType === 'story' && editParams)" no-gutters class="tw-mt-8">
          <div>
            <div class="">
              <v-icon small class="">mdi-tune</v-icon>
              <div class="tw-font-bold tw-inline tw-ml-6">Parameters</div>
            </div>
          </div>
          <div class="tw-inline-block tw-ml-9 tw-mt-3 tw-w-full">
            <div>
              <div class="tw-pb-4"
                v-for="(item, index) in storeState.block.params"
                :key="index"
              >
                <div class="tw-cursor-pointer tw-inline-block tw-pl-1 hover:tw-font-bold tw-rounded">
                  <v-select
                    :items="paramTypes.filter(p => (['sql', 'airtableAsSql', 'snippet'].includes(storeState.block.cellType) && p.dbSource) || !['sql', 'airtableAsSql', 'snippet'].includes(storeState.block.cellType))"
                    v-model="item.type"
                    item-text="label"
                    item-value="key"
                    label=""
                    required
                    placeholder="Type"
                    dense
                    class="denser tw-inline-block"
                  >
                  <template v-slot:selection="data">
                      <div :data-type="data.item.value" class="tw-cursor-pointer">
                        <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                        <span class="tw-pl-0">{{data.item.label}}</span>
                      </div>
                    </template>
                    <template v-slot:item="data">
                      <div :data-type="data.item.value" class="tw-cursor-pointer">
                        <v-icon small>{{data.item.icon}}</v-icon>
                        <span class="tw-pl-2">{{data.item.label}}</span>
                      </div>
                    </template>
                    <template v-slot:append-item>
                      <div @click="openParamsDocs" class="tw-cursor-pointer tw-ml-4 tw-my-2">
                        <!-- <v-icon small>mdi-help-circle</v-icon> -->
                        <span class="tw-pl-2">Need help?</span>
                      </div>
                    </template>
                  </v-select>
                  <v-icon 
                    small
                    @click="deleteParam(item, index)"
                    class="tw-absolute tw-mr-12 tw-right-0"
                  >
                    mdi-delete
                  </v-icon>
                </div>
                <div class="tw-pl-1">
                  <v-text-field
                    v-if="item.type != 'lookup'"
                    v-model="item.name" 
                    autocomplete="off"
                    placeholder="Name"
                    :ref="'param_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                </div>
                <div v-if="item.type === 'zendesk'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    placeholder="SQL"
                    :ref="'param__value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                  <v-autocomplete
                    v-model="item.attribute"
                    :items="storeState.integrations.zendesk.user.filter(f => !f['read-only'] || f['read-only'] != 'yes')"
                    placeholder="Field Name"
                    item-text="name"
                    item-value="name"
                    return-object
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <!-- <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshIntercomAttributes" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template> -->
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'hubspot'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    placeholder="SQL"
                    :ref="'param__value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                  <v-autocomplete
                    v-model="item.field"
                    :items="storeState.integrations.hubspot.contacts"
                    placeholder="Field Name"
                    item-text="name"
                    item-value="name"
                    return-object
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <!-- <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshIntercomAttributes" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template> -->
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'sfdc'" class="tw-pl-1">
                  <!-- {{storeState.sfdcMetadata}} -->
                  <div v-if="!storeState.block.destination.sfdc.object || !storeState.block.destination.sfdc.object.name">
                    Select an Object in SalesForce as your destination first
                  </div>
                  <div v-else>
                    <!-- <v-text-field
                      v-model="item.value" 
                      autocomplete="off"
                      placeholder="Column"
                      :ref="'param__value_' + item.name"
                      hint=""
                      dense
                      class="denser"
                      >
                    </v-text-field> -->
                    <div class="">
                      <!-- {{fromTse.columnsAndData}} -->
                      <v-autocomplete
                        :ref="'param_thoughtspot_' + index"
                        v-model="item.value"
                        :items="fromTse.columnsAndData.columns.map(c => c.column)"
                        placeholder="Column"
                        item-text="name"
                        item-value="name"
                        :rules="[fieldRules.required]"
                        required
                        auto-select-first
                        single-line
                        dense
                        autocomplete="off"
                        class="denser"
                      >
                        <!-- <template v-slot:selection="data">
                          <div class="tw-cursor-pointer">
                            <span class="tw-pl-0">{{data.item.name}}</span>
                          </div>
                        </template> -->
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title>
                              <v-btn @click="refreshTse" text>Refresh</v-btn>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                            <div>
                              {{item.name}}
                            </div>
                        </template>
                      </v-autocomplete>
                    </div>
                    <v-autocomplete
                      v-model="item.attribute"
                      :items="storeState.sfdcMetadata[storeState.block.destination.sfdc.object.name]"
                      placeholder="Attribute Name"
                      item-text="label"
                      item-value="name"
                      return-object
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    >
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="getSfdcMetadata2" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                  
                </div>
                <div v-if="item.type === 'intercom'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    placeholder="SQL"
                    :ref="'param__value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                  <v-autocomplete
                    v-model="item.attribute"
                    :items="storeState.destinations.intercom.attributes"
                    placeholder="Attribute Name"
                    item-text="full_name"
                    item-value="full_name"
                    return-object
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshIntercomAttributes" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'drill'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    placeholder="SQL"
                    :ref="'param__value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                  <v-autocomplete
                    v-model="item.drillToBlock"
                    :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                    placeholder="Drill to"
                    item-text="title"
                    item-value="uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    @change="onNewParamBlock(item, index)"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'editable'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    placeholder="SQL"
                    :ref="'param__value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                  <v-autocomplete
                    v-model="item.updateWithBlock"
                    :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                    placeholder="Update with"
                    item-text="title"
                    item-value="uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    @change="onNewParamBlock(item, index)"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <div 
                    v-if="item.updateWithBlock" 
                    class="tw--mt-12 tw-absolute tw-mr-8 tw-right-0"
                  >
                    <v-tooltip bottom dark color="#333">
                      <template v-slot:activator="{ on }">
                        <button 
                          @click="newWindow(item.updateWithBlock)"
                          v-on="on" 
                          class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                          @mouseenter="actionBtns.openForm = true"
                          @mouseleave="actionBtns.openForm = false"
                        >
                          <v-icon :color="actionBtns.openForm ? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-open-in-new</v-icon>
                        </button>
                      </template>
                      <span class="tooltip-text">Open Block</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="item.type === 'lookup'" class="tw-pl-1">
                  <v-autocomplete
                    v-model="item.lookup"
                    :items="storeState.block.params.filter(p => p.name != item.name)"
                    placeholder="Lookup"
                    item-text="name"
                    item-value="name"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  > 
                    <template v-slot:no-data>
                      <v-list-item v-if="item.blockId">
                        <v-list-item-title @click="newWindow(item.blockId)">
                          Run block first, click to open
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="item.blockId"
                    :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                    placeholder="In Block"
                    item-text="title"
                    item-value="uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    @change="onNewParamBlock(item, index)"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="item.column"
                    v-if="item.blockId"
                    :items="storeState.blocks[item.blockId].params"
                    :search-input.sync="paramColumnSearches[index]"
                    placeholder="Match to"
                    item-text="name"
                    item-value="name"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  > 
                    <template v-slot:no-data>
                      <v-list-item v-if="item.blockId">
                        <v-list-item-title @click="newWindow(item.blockId)">
                          Run block first, click to open
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'pivot'" class="tw-pl-1">
                  <v-select
                    :items="pivotTypes"
                    v-model="item.pivotType"
                    item-text="label"
                    item-value="key"
                    label=""
                    required
                    placeholder="Type"
                    dense
                    class="denser"
                  >
                  <template v-slot:selection="data">
                      <div :data-type="data.item.value" class="tw-cursor-pointer">
                        <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                        <span class="tw-pl-0">{{data.item.label}}</span>
                      </div>
                    </template>
                    <template v-slot:item="data">
                      <div :data-type="data.item.value" class="tw-cursor-pointer">
                        <v-icon small>{{data.item.icon}}</v-icon>
                        <span class="tw-pl-2">{{data.item.label}}</span>
                      </div>
                    </template>
                  </v-select>
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    placeholder="Name"
                    :ref="'param__value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                </div>
                <div v-if="item.type === 'select'" class="tw-pl-1">
                  <v-autocomplete
                    v-model="item.blockId"
                    :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                    placeholder="Block title"
                    item-text="title"
                    item-value="uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    @change="onNewParamBlock(item, index)"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="item.column"
                    v-if="item.blockId"
                    :items="getBlockHeaders(item.blockId)"
                    :search-input.sync="paramColumnSearches[index]"
                    placeholder="Column"
                    item-text="text"
                    item-value="value"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    @change="updateSelectOptions(item, index)"
                  > 
                    <template v-slot:no-data>
                      <v-list-item v-if="item.blockId">
                        <v-list-item-title @click="newWindow(item.blockId)">
                          Run block first, click to open
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="item.value"
                    v-if="item.column"
                    :items="item.options"
                    :search-input.sync="paramOptionSearches[index]"
                    placeholder="Value"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  > 
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshParamOptions(item.blockId, index)" text>Refresh options</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item v-if="storeState.block.trigger.blockId">
                        <v-list-item-title @click="newWindow(storeState.block.trigger.blockId)">
                          Run block first, click to open
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'excel'" class="tw-pl-1">
                  <v-autocomplete
                    v-model="item.fileId"
                    :items="storeState.destinations.gdWorkbooks"
                    placeholder="Workbook"
                    item-text="name"
                    item-value="id"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshGdWorkbooks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-model="item.sheet" 
                    autocomplete="off"
                    :placeholder="`Sheet1!A1:D10`"
                    :ref="'param_' + item.name"
                    hint=""
                    :rules="[fieldRules.required]"
                    dense
                    class="denser"
                    >
                  </v-text-field>
                </div>
                <div v-if="item.type === 'thoughtspot'" class="tw-pl-1">
                  <!-- {{fromTse.columnsAndData}} -->
                  <v-autocomplete
                    :ref="'param_thoughtspot_' + index"
                    v-model="item.name"
                    :items="fromTse.columnsAndData.columns.map(c => c.column)"
                    placeholder="Column"
                    item-text="name"
                    item-value="id"
                    :rules="[fieldRules.required]"
                    required
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <!-- <template v-slot:selection="data">
                      <div class="tw-cursor-pointer">
                        <span class="tw-pl-0">{{data.item.name}}</span>
                      </div>
                    </template> -->
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshTse" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                        <div>
                          {{item.name}}
                        </div>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'sheets'" class="tw-pl-1">
                  <v-autocomplete
                    :ref="'param_spreadsheet_' + index"
                    v-model="item.spreadSheet"
                    :items="storeState.destinations.spreadSheets"
                    placeholder="Spreadsheet"
                    item-text="name"
                    item-value="id"
                    :rules="[fieldRules.required]"
                    required
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshSpreadSheets" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    :ref="'param_sheet_' + index"
                    v-model="item.sheet" 
                    autocomplete="off"
                    :placeholder="`Sheet1!A1:D10`"
                    hint=""
                    :rules="[fieldRules.required]"
                    dense
                    class="denser"
                    >
                  </v-text-field>
                  
                </div>
                <div v-if="item.type === 'file'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.url" 
                    autocomplete="off"
                    :placeholder="'File URL'"
                    :ref="'param_url_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                </div>
                <div v-if="item.type === 'subquery'" class="tw-pl-1">
                  <v-autocomplete
                    v-model="item.subqueryId"
                    :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                    placeholder="Block title"
                    item-text="title"
                    item-value="uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'block'" class="tw-pl-1">
                  <v-autocomplete
                    v-model="item.blockId"
                    :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                    placeholder="Block title"
                    item-text="title"
                    item-value="uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div 
                  v-if="item.type === 'block' && item.blockId && storeState.blocks[item.blockId].cellType === 'python' &&
                        storeState.blocks[item.blockId].python && storeState.blocks[item.blockId].python.dfNames"
                  class="tw-pl-1"
                >
                  <v-autocomplete
                    v-model="item.dfName"
                    :items="storeState.blocks[item.blockId].python.dfNames"
                    placeholder="DataFrame"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div v-if="item.type === 'value'" class="tw-pl-1">
                  <v-text-field
                    v-model="item.value" 
                    autocomplete="off"
                    :placeholder="'Value'"
                    :ref="'param_value_' + item.name"
                    hint=""
                    dense
                    class="denser"
                    >
                  </v-text-field>
                </div>
              </div>
            </div>
          </div>
          <div class="tw-ml-10 tw-mt-0 tw-mb-4">
            <button @click="editParams = false" class="hover:tw-bg-gray-300 tw-font-bold tw-p-1 tw-rounded">
              Save
            </button>
            <button v-if="!addingLookup && storeState.block.params.length > 0 && storeState.block.params.filter(p => p.type === 'lookup').length === 0" @click="addLookup" class="tw-ml-8 hover:tw-bg-gray-300 tw-font-bold tw-p-1 tw-rounded">
              Add lookup
            </button>
          </div>
        </div>
      </div>
      
      <!-- END SOURCE / DEST -->
      <!-- START ERRORS (shown in red) -->
      <div class="tw-mt-8" v-if="storeState.paramError">
        {{storeState.paramError}}
      </div>

      <div class="tw-mt-8" v-if="storeState.dbError">
        <div class="tw-mt-4 tw-text-red-600 tw-font-bold">
          Query Error
        </div>
        <div class="tw-mt-4 tw-text-red-600">
          {{storeState.dbError}}
        </div>
        <div class="tw-mt-8">
          <div 
            class="tw-cursor-pointer tw-font-bold tw-inline"
            @click="googleDbError"
          >
            Google Error
          </div>
          <div 
            class="tw-cursor-pointer tw-font-bold tw-inline tw-pl-8 tw-text-gray-500"
            @click="storeState.dbError = false"
          >
            Dismiss
          </div>
        </div>
      </div>
      <div class="tw-mt-8 tw-text-red-600" v-else-if="storeState.block.cellType === 'json'">
        {{jsonParseError}}
      </div>
      <div 
        v-else-if="this.storeState.block.cellType ==='story' && this.storeState.block.story.blocks.length > 0"
        class="tw-mt-8"
      >
        <div class="tw-font-bold tw-pb-2">Blocks</div>
        <div
          v-for="(storyBlock, index) in storeState.block.story.blocks"
          :key="`${index}-${storyBlock.blockId}`"
          class="tw-cursor-pointer tw-pb-4"
          @click="newWindow(storyBlock.blockId)"
        >
          {{storeState.blocks[storyBlock.blockId] ? storeState.blocks[storyBlock.blockId].title : ''}}
        </div>

      </div>
      <div 
        v-else-if="storeState.block.repeat.period === 'hourly' && storeState.block.repeat.minutesPast === ''"
        class="tw-mt-8 tw-cursor-pointer tw-text-red-600"
        @click="focusMinutesPast"
      >
        You need to select a minutes past for your hourly schedule
      </div>
      <!-- START SCHEMA -->
      <div v-else-if="onlyDestination">
        <!-- nothing -->
      </div>

    </div>
    <!-- END SIDEBAR -->
    <!-- ADD SOURCE -->
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce'
import { store } from '../store.js';
import { codemirror } from 'vue-codemirror'
import _ from 'lodash';
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'

// import '../assets/styles/codemirror.css'
import '../../node_modules/codemirror/lib/codemirror.css'
import '../../node_modules/codemirror/theme/solarized.css'
import '../../node_modules/codemirror/mode/sql/sql.js'
import '../../node_modules/codemirror/mode/python/python.js'
import '../../node_modules/codemirror/mode/javascript/javascript.js'
import '../../node_modules/codemirror/addon/display/placeholder.js'
import '../../node_modules/codemirror/addon/display/autorefresh.js'
import '../../node_modules/codemirror/addon/comment/comment.js'
import '../../node_modules/codemirror/addon/edit/matchbrackets.js'
import '../../node_modules/codemirror/addon/edit/closebrackets.js'

var toggleComment = require('codemirror/addon/comment/comment.js');
function toggleSqlComment(cm) {
  cm.toggleComment({
    indent: true,
    lineComment: '--'
  });
}

var CodeMirror = require('../../node_modules/codemirror/lib/codemirror.js')

import DataTag from './DataTag.js'
// import Table from './SwTable.js'
// import ClearDataTag from './ClearDataTag.js'
// import EmptyMark from './EmptyMark.js'
import { DOMParser } from 'prosemirror-model'


import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble, Extension } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  // Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Placeholder,
  Table,
  TableHeader,
  TableCell,
  TableRow,
} from 'tiptap-extensions'

document.body.setAttribute('data-app', true)

export default {
  updated() {
    var el = document.getElementById('intercom-container')
    if (el) el.parentNode.removeChild(el);
  },
  mounted() {
    var el = document.getElementById('intercom-container')
    if (el) el.parentNode.removeChild(el);
    window.bus.$on('doneGetOneBlockFromFlask', (details) => {
      this.getBlock(details.blockId)
    })
    window.bus.$on('addSnippet', (details) => {
      if (!this.storeState.cmdkActive) return
      console.log('window.bus: ', details)
      let doc = window.editor.getDoc()
      var cur = editor.getCursor()
      let block = details.block
      var snippet = ''
      if (block.cellType === 'sql') {
        this.storeState.block.params = block.params
      } else if (this.storeState.block.cellType === 'snippet') {
        this.storeState.block.params = block.params
      } else if (block.params) {
        let params = {}
        for (let i = 0; i < block.params.length; i++) {
          params[block.params[i].name] = block.params[i].value
        }
        snippet = store.interpolate(block.code)(params)
        doc.replaceRange(snippet, cur)
      } else {
        snippet = block.code
        doc.replaceRange(snippet, cur)
      }
      this.focusCm()
      this.storeState.cmdkActive = false
      this.storeState.cmdkParentCmd = false
      this.storeState.cmdkForm = false
      this.storeState.cmdkInput = ''
      this.storeState.searchIndex = 0
    });
    window.bus.$on('insertHTML', (details) => {
      this.insertHTML({state: details.state, view: details.view}, details.html)
    })
    window.bus.$on('getSoupSheets', (details) => {
      this.loadingSpreadsheets = false
    })
    window.bus.$on('getGoogleDriveWorkbooks', (details) => {
      this.loadingWorkbooks = false
    })
    window.bus.$on('doneGettingSources', (details) => {
      this.getExplore(this)
    })
    window.bus.$on('doneRun', (details) => {
      if (details.ok && (this.showChart || this.storeState.viewNumber === 4)) {
        this.makeChart()
      }
    })
    window.bus.$on('doneStoryRun', (details) => {
      if (details.ok && (details.html)) {
        // this.tiptap.setContent(details.html)
        store.state.block.story.htmlPreview = details.html
      }
    })
  },
  data() {
    return {
      store: store,
      storeState: store.state,
      fromTse: {},
      onlyDestination: false,
      manualDestinationError: false,
      addingLookup: false,
      hoverBlock: false,
      showPendingEdits: false,
      renderedSnippet: '',
      blockHistoryHover: -1,
      blockHistoryPosition: -1,
      linkUrl: null,
      paramColumnSearches: [],
      paramOptionSearches: [],
      linkMenuIsActive: false,
      destination: store.state.block.destination,
      viewNumber: store.state.viewNumber,
      dbSchemas: store.state.dbMeta.schemas,
      loadingSpreadsheets: false,
      needsHelp: false,
      actionBtns: {},
      onIoSplit: false,
      currentRunTime: store.state.currentRunTime,
      allowFullCmChangeProcess: true,
      appendReplace: 'replace',
      stopResize: true,
      dateNlpSearch: '',
      pauseDestination: false,
      linkColor: 'color: rgb(46, 170, 220)',
      iconLookUp: {
        number: 'mdi-numeric',
        string: 'mdi-format-text',
        date: 'mdi-calendar-blank',
        time: 'mdi-calendar-blank',
      },
      noValueOperators: ['isNotNull', 'isNull'],
      filterSuggestions: [],
      filterOperators: {
        number: [
          {display: '=', sql: '$field = $value', text: 'Equal to', key: 'equalTo'},
          {display: '≠', sql: '!=', text: 'Not equal to', key: 'notEqualTo'},
          {display: '≥', sql: '>=', text: 'Greater than or equal to', key: 'gte'},
          {display: '≤', sql: '<=', text: 'Less than or equal to', key: 'lte'},
          {display: '>', sql: '>', text: 'Greater than', key: 'gt'},
          {display: '<', sql: '<', text: 'Less than', key: 'lt'},
          {display: 'Null', sql: 'IS NULL', text: 'Null', key: 'isNull'},
          {display: 'Not Null', sql: 'IS NOT NULL', text: 'Not Null', key: 'isNotNull'},
        ],
        string: [
          {display: 'Is', sql: '=', text: 'Is', key: 'notNull'},
          {display: 'Is Not', sql: '!=', text: 'Is not', key: 'notNull'},
          {display: 'Contains', sql: `$field LIKE '%$value%'`, text: 'Contains', key: 'contains'},
          {display: 'Does not contain', sql: `$field NOT LIKE '%$value%'`, text: 'Contains', key: 'notContain'},
          {display: 'Starts With', sql: `$field LIKE '$value%'`, text: 'Contains', key: 'startsWith'},
          {display: 'Ends With', sql: `$field LIKE '%$value'`, text: 'Contains', key: 'endsWith'},
          {display: 'Is Null', sql: `$field IS NULL`, text: 'Is Null', key: 'isNull'},
          {display: 'Is Not Null', sql: '$field IS NOT NULL', text: 'Is Not Null', key: 'isNotNull'},
        ],
        time: [
          {display: 'Is', sql: `CAST($field AS DATE) = '$value'`, text: 'Is', key: 'exactDate', dateNlp: true},
          {display: 'Is in the past', sql: `$field > current_date - interval '$num' $period`, 
            text: 'Is', key: 'dateInThePast', dateNlp: false, period: true},
          {display: 'Is on or after', sql: `$field >= '$value'`, text: 'Is after', key: 'dateOnOrAfter', dateNlp: true},
          {display: 'Is after', sql: `$field > '$value'`, text: 'Is after', key: 'dateAfter', dateNlp: true},
          {display: 'Is on or before', sql: `$field <= '$value'`, text: 'Is after', key: 'dateOnOrBefore', dateNlp: true},
          {display: 'Is before', sql: `$field < '$value'`, text: 'Is after', key: 'dateBefore', dateNlp: true},
        ]
      },
      showSidebar: false,
      andOr: [
        {text: 'And', value: 'and'},
        {text: 'Or', value: 'or'},
      ],
      showFilters: false,
      // https://coolors.co/50514f-f25f5c-ffe066-247ba0-70c1b3
      defaultColorScheme: [
        {color: '#F25F5C', nickname: 'red', primary: true},
        {color: '#247BA0', nickname: 'blue', primary: true},
        {color: '#FFE066', nickname: 'yellow', primary: false},
        {color: '#70C1B3', nickname: 'green', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#fff', nickname: 'white', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
      ],
      chartStyles: {
        height: '400px',
        width: '100%',
        position: 'relative',
      },
      chartReady: false,
      showTable: true,
      showChart: false,
      showSql: false,
      showSnippet: false,
      showContextMenu: false,
      whitelistError: false,
      contextData: {},
      contextOptions: [],
      datacollection: null,
      upDownInitiated: false,
      suggestionTop: '0px',
      suggestionLeft: '-1000px',
      suggestionOverlayTop: '0px',
      suggestionOverlayLeft: '-1000px',
      searchTerm: '',
      origSearchTerm: '',
      beforeSearch: '',
      maxSuggestions: 7,
      tagInput: '',
      tagRules: [
        v => false
      ],
      editingTag: false,
      jsonParseError: '',
      newTag: '',
      showBlockActions: false,
      historyOpen: false,
      connectError: '',
      sourceRules: {
        required: value => !!value || 'Required.',
        portMin: v => v.length >= 2 || 'Min 2 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      fieldRules: {
        required: value => !!value || 'Required.',
        portMin: v => v.length >= 2 || 'Min 2 characters',
        isNum: v => !isNaN(v) || 'Must be a number, use -1 for last day of the month',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      snowRegions: [
        //https://docs.snowflake.com/en/user-guide/intro-regions.html#specifying-region-information-in-your-account-hostname
        //aws
        "us-west-1", 
        "us-west-2", 
        "us-east-1", 
        "us-east-2.aws", 
        "us-east-1-gov.aws",
        "eu-west-1", 
        "eu-central-1", 
        "ca-central-1.aws", 
        "ap-southeast-1", 
        "ap-southeast-2", 
        "ap-northeast-1.aws",
        //azure
        "us-east-2.azure", 
        "east-us-2.azure", 
        "west-us-2.azure",
        "us-gov-virginia.azure", 
        "canada-central.azure",
        "west-europe.azure", 
        "australia-east.azure",
        "southeast-asia.azure",
        //gcp
        "us-central1.gcp", 
        "europe-west2.gcp", 
        "europe-west4.gcp", 
      ],
      hoverDestination: false,
      hoverRepeat: false,
      hoverSource: false,
      hoverParams: false,
      intervals: [
        {value: 'hourly', text: 'Hourly'},
        {value: 'daily', text: 'Daily'},
        {value: 'weekly', text: 'Weekly'},
        {value: 'monthly', text: 'Monthly'},
        {value: 'fivemin', text: '5 minutes'},
        
      ],
      daysOfWeek: [
        {value: 'monday', text: 'Monday'},
        {value: 'tuesday', text: 'Tuesday'},
        {value: 'wednesday', text: 'Wednesday'},
        {value: 'thursday', text: 'Thursday'},
        {value: 'friday', text: 'Friday'},
        {value: 'saturday', text: 'Saturday'},
        {value: 'sunday', text: 'Sunday'},
      ],
      searchSheet: null,
      searchSpreadsheet: null,
      searchWorkbook: null,
      searchGdWorkbook: null,
      searchTable: null,
      searchPrimaryKey: null,
      showDestination: true,
      editDestination: true,
      editRepeat: false,
      editParams: false,
      loadingSheets: false,
      loadingMeta: false,
      dbTypes: [
        {key: 'mysql', label: 'MySQL', portHint: 'e.g. 3306'}, 
        {key: 'postgres',  label: 'Postgres', portHint: 'e.g. 5432'},
        {key: 'snowflake',  label: 'Snowflake'},
        {key: 'mssql',  label: 'MS SQL Server', portHint: 'e.g. 1433'},
        {key: 'redshift',  label: 'Redshift', portHint: 'e.g. 5439'},
        {key: 'bigquery',  label: 'BigQuery', portHint: 'na'},
        {key: 'airtable',  label: 'Airtable', portHint: 'na'},
      ],
      paramTypes: [
        {key: 'value', label: 'Value', blockSource: true, dbSource: true},
        {key: 'sheets', label: 'Sheets', blockSource: true, dbSource: true},
        {key: 'thoughtspot', label: 'ThoughtSpot', blockSource: true, dbSource: true},
        {key: 'excel', label: 'Excel', blockSource: true, dbSource: true},
        {key: 'file', label: 'CSV', blockSource: true, dbSource: false},
        {key: 'block', label: 'Block', blockSource: true, dbSource: false},
        {key: 'subquery', label: 'Subquery', blockSource: true, dbSource: true},
        {key: 'drill', label: 'Drill Down', blockSource: true, dbSource: true},
        {key: 'pivot', label: 'Pivot', blockSource: true, dbSource: true},
        {key: 'select', label: 'Select', blockSource: true, dbSource: true},
        {key: 'lookup', label: 'Lookup', blockSource: true, dbSource: true},
        {key: 'editable', label: 'Editable', blockSource: true, dbSource: true},
        {key: 'sfdc', label: 'SalesForce', blockSource: true, dbSource: true},
        {key: 'intercom', label: 'Intercom', blockSource: true, dbSource: true},
        {key: 'zendesk', label: 'Zendesk', blockSource: true, dbSource: true},
        {key: 'hubspot', label: 'Hubspot', blockSource: true, dbSource: true},
        // {key: 'api', label: 'API'},
      ],
      destinationBlockTypes: [
        {key: 'loopThruDestination', label: 'Loop thru destination'},
        {key: 'loopThruRows', label: 'Loop thru rows'},
      ],
      pivotTypes: [
        {key: 'column', label: 'Column'},
        {key: 'value', label: 'Value'},
      ],
      sfdcOperations: [
        {key: 'insert', label: 'insert'},
        {key: 'delete', label: 'delete'},
        {key: 'hardDelete', label: 'hardDelete'},
        {key: 'update', label: 'update'},
        {key: 'upsert', label: 'upsert'},
      ],
      intercomRoleTypes: [
        {key: 'user', label: 'user'},
        {key: 'lead', label: 'lead'},
      ],
      intercomKeyTypes: [
        {key: 'external_id', label: 'external_id'},
        {key: 'email', label: 'email'},
      ],
      zendeskKeyTypes: [
        {key: 'external_id', label: 'external_id'},
        {key: 'id', label: 'id'},
      ],
      zendeskObjects: [
        {key: 'users', label: 'users'},
        {key: 'tickets', label: 'tickets'},
      ],
      zendeskEndpoints: [
        {key: 'update_many', label: 'Update'},
        {key: 'create_or_update_many', label: 'Create or Update'},
      ],
      databaseOperations: [
        // {key: 'update', label: 'update'},
        {key: 'create', label: 'Create / Replace'},
        {key: 'append', label: 'Append'},
        // {key: 'archive', label: 'archive'},
      ],
      hubspotObjects: [
          {
            key: 'contacts',
            label: 'contacts',
          },
          {
            key: 'companies',
            label: 'companies'
          },
          {
            key: 'deals',
            label: 'deals'
          },
          {
            key: 'tickets',
            label: 'tickets'
          }
      ],
      hubspotOperations: [
        {key: 'update', label: 'update'},
        {key: 'create', label: 'create'},
        // {key: 'archive', label: 'archive'},
      ],
      hubspotKeyTypes: [
        {key: 'email', label: 'email'},
        {key: 'id', label: 'id'},
      ],
      showPass: false,
      newSource: {
        name: '',
        db_type: 'mysql',
        host: '',
        port: '',
        ssl: false,
        username: '',
        password: '',
        database: '',
        metadata: false,
      },
      addingTrigger: false,
      savingSource: false,
      addingSchedule: false,
      savingSchedule: false,
      cmOptions: {
        tabSize: 4,
        mode: 'text/x-mysql',
        lineNumbers: true,
        line: false,
        placeholder: 'Write SQL here...',
        autofocus: store.state.cmAutofocus,
        matchBrackets: true,
        autoCloseBrackets: true,
        autoRefresh: true,
        extraKeys: {
          'Shift-Tab': 'indentLess',
          "Cmd-/": toggleSqlComment,
          "Ctrl-/": toggleSqlComment,
          "Tab": this.handleTab,
          "Enter": this.handleEnter,
          "Up": this.handleUp,
          "Down": this.handleDown,
        }
      },
      cmManualOptions: {
        tabSize: 2,
        mode: 'application/ld+json',
        line: false,
        placeholder: 'Add destination...',
        autofocus: store.state.cmAutofocus,
        matchBrackets: true,
        autoCloseBrackets: true,
        autoRefresh: true,
        // extraKeys: {
        //   'Shift-Tab': 'indentLess',
        //   "Tab": this.handleTab,
        //   "Enter": this.handleEnter,
        //   "Up": this.handleUp,
        //   "Down": this.handleDown,
        // }
      },
      tiptap: new Editor({
        onUpdate: ( { state, getHTML, getJSON, transaction } ) => {
          store.state.block.story.json = getJSON()
          var html = getHTML()
          store.state.block.story.html = html
          for (let i = 0; i < store.state.block.params.length; i++) {
            const re = RegExp(`{{(${store.state.block.params[i].name})}}`, 'g')
            html = html.replace(re, store.state.block.params[i].value);
          }
          try {
            html = html.replace(
              /{{([^}]*)}}/g, 
              function (math) {
                var el = document.createElement( 'html' );
                el.innerHTML = math
                return eval(el.textContent);
            });
            store.state.mathError = ''
          } catch (error) {
            store.state.mathError = error.message
          }
          
          store.state.block.story.htmlPreview = html
          // store.state.block.story.html = html
          var after = ''
          var before = ''
          if (state.selection.$from.nodeAfter) after = state.selection.$from.nodeAfter.textContent
          if (state.selection.$from.nodeBefore) before = state.selection.$from.nodeBefore.textContent
          if (before) {
            var beforeParts = before.split('=')
            if (beforeParts.length > 1) {
              this.storeState.searchTerm = beforeParts[beforeParts.length-1]
              this.getStorySuggestions(
                {
                  searchTerm: this.storeState.searchTerm, 
                  state: state,
                }
              )
            } else {
              this.storeState.showSuggestions = false
            }
          }
        },
        editorProps: {
          handleKeyDown: (editor, e) => {
          // console.log(`key from prose ${e}`, e)
          },
          handleDOMEvents: {
            mouseover: (view, event) => {
              if (event.target && event.target.dataset && event.target.dataset.title) {
                this.dataTagHover = Object.assign({}, event.target.dataset)
              } else {
                this.dataTagHover = ''
              }
            },
            click: (view, event) => {
              if (event.target && event.target.dataset && event.target.dataset.blockId) {
                this.newWindow(event.target.dataset.blockId)
              }
            },
          },
        },
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          // new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new DataTag(),
          new Table({
            resizable: true,
          }),
          new TableHeader(),
          new TableCell(),
          new TableRow(),
          new Placeholder({
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            emptyNodeText: 'Write your story here, use `=` to add data, use `{{2+2}}` to do math.',
          }),
          new class extends Extension {
            keys() {
              return {
                Enter(state, dispatch, view) {
                  console.log('ENTERRRRRRRRR from prosemirror')
                  if (store.state.showSuggestions && store.state.searchIndex >= 0) {
                    let suggestion = store.state.compositionSuggestions[store.state.searchIndex]
                    if (suggestion && suggestion.type === 'block') {
                      let curPos = view.state.tr.curSelection.$anchor.pos
                      let start = curPos - (store.state.searchTerm.length+1)
                      let blockToAdd = store.state.blocks[suggestion.blockId]
                      let headers = blockToAdd.results.headers.slice(0, 20)
                      let rows = blockToAdd.results.rows.slice(0, 20)
                      var table = `<table class="tw-table-auto" data-block-id="${suggestion.blockId}"><thead><tr>`
                      let blockNum = 99 - store.state.block.story.blocks.length
                      for (let index = 0; index < headers.length; index++) {
                        table += `<th class="tw-px-4 tw-py-2">${headers[index].text}</th>`
                      }
                      table+= `</thead><tbody>`
                      for (let index = 0; index < rows.length; index++) {
                        const row = rows[index];
                        table += `<tr>`
                        for (let index2 = 0; index2 < headers.length; index2++) {
                          table += `<td data-block-id="12345" style="background-color:rgba(255, 255, 255, .${blockNum});"`
                          table += `class="tw-border tw-px-4 tw-py-2">${row[headers[index2].text]}</td>`
                        }
                        table += `</tr>`
                      }
                      table += `</tbody></table><br>`
                      store.state.block.story.blocks.push({blockId: suggestion.blockId, blockNum: blockNum})
                      const { selection } = state
                      const element = document.createElement('div')
                      element.innerHTML = table.trim()
                      const slice = DOMParser.fromSchema(state.schema).parseSlice(element)
                      const transaction = state.tr.insert(selection.anchor, slice.content)
                      view.dispatch(transaction)
                      const ct = view.state.tr.insertText('', start, curPos)
                      view.dispatch(ct)
                      view.focus()
                      store.state.showSuggestions = false
                      return true
                    } else if (suggestion) {
                      let curPos = view.state.tr.curSelection.$anchor.pos
                      let start = curPos - (store.state.searchTerm.length+1)
                      const transaction = view.state.tr.insertText('', start, curPos)
                      view.dispatch(transaction)
                      let node = state.schema.nodes.datatag.create({
                        uuid: suggestion.uuid, 
                        value: suggestion.value,
                        blockId: suggestion.blockId,
                        title: suggestion.title,
                        path: suggestion.path,
                      })
                      const insertTrans = view.state.tr.insert(view.state.selection.$anchor.pos, node)
                      view.dispatch(insertTrans)
                      view.focus()
                    }
                    store.state.showSuggestions = false
                    return true
                  } else {
                    return false
                  }
                },
                'Mod-Enter'(state, dispatch, view) {
                  console.log('Mod from prosemirror')
                  store.runCode({})
                },
                'Mod-['(state, dispatch, view) {
                  console.log('Mod back')
                },
                Tab(state, dispatch, view) {
                  console.log('tabbbbbb from prosemirror')
                  if (store.state.showSuggestions) {
                    var index = 0
                    if (store.state.searchIndex > 0) index = store.state.searchIndex 
                    let suggestion = store.state.compositionSuggestions[index]
                    if (suggestion && suggestion.type === 'block') {
                      let curPos = view.state.tr.curSelection.$anchor.pos
                      let start = curPos - (store.state.searchTerm.length+1)
                      let blockToAdd = store.state.blocks[suggestion.blockId]
                      let headers = blockToAdd.results.headers.slice(0, 20)
                      let rows = blockToAdd.results.rows.slice(0, 20)
                      var table = `<table class="tw-table-auto" data-block-id="${suggestion.blockId}"><thead><tr>`
                      let blockNum = 99 - store.state.block.story.blocks.length
                      for (let index = 0; index < headers.length; index++) {
                        table += `<th class="tw-px-4 tw-py-2">${headers[index].text}</th>`
                      }
                      table+= `</thead><tbody>`
                      for (let index = 0; index < rows.length; index++) {
                        const row = rows[index];
                        table += `<tr>`
                        for (let index2 = 0; index2 < headers.length; index2++) {
                          table += `<td data-block-id="12345" style="background-color:rgba(255, 255, 255, .${blockNum});"`
                          table += `class="tw-border tw-px-4 tw-py-2">${row[headers[index2].text]}</td>`
                        }
                        table += `</tr>`
                      }
                      table += `</tbody></table><br>`
                      store.state.block.story.blocks.push({blockId: suggestion.blockId, blockNum: blockNum})
                      // https://github.com/scrumpy/tiptap/issues/385
                      const { selection } = state
                      const element = document.createElement('div')
                      element.innerHTML = table.trim()
                      const slice = DOMParser.fromSchema(state.schema).parseSlice(element)
                      const transaction = state.tr.insert(selection.anchor, slice.content)
                      view.dispatch(transaction)
                      
                      const ct = view.state.tr.insertText('', start, curPos)
                      view.dispatch(ct)
                      view.focus()
                      store.state.showSuggestions = false
                      return true
                    }
                    else if (suggestion) {
                      let curPos = view.state.tr.curSelection.$anchor.pos
                      let start = curPos - (store.state.searchTerm.length+1)
                      const transaction = view.state.tr.insertText('', start, curPos)
                      view.dispatch(transaction)
                      let node = state.schema.nodes.datatag.create({
                        uuid: suggestion.uuid, 
                        value: suggestion.value,
                        blockId: suggestion.blockId,
                        title: suggestion.title,
                        path: suggestion.path,
                      })
                      const insertTrans = view.state.tr.insert(view.state.selection.$anchor.pos, node)
                      view.dispatch(insertTrans)
                      view.focus()
                    }
                    store.state.showSuggestions = false
                    return true
                  } else {
                    return false
                  }
                },
              }
            }
          }(),
        ],
        content: ``,
      }),
    };
  },
  filters: {
    dateFilter: function (date) {
      console.log(date)
      date = date.fromNow()
      return date
      // return moment(date).fromNow();
    }
  },
  computed: {
    getSenders() {
      return this.storeState.settings.team.members
    },
    getRunTime() {
      let runTime = moment.unix(moment()).utc()._i - this.storeState.block.results.meta.lastRun
      return (runTime / 1000000).toFixed(2)
    },
    // renderedSnippet() {
    //   console.log('renderedSnippet...')
    //   let block = this.storeState.block
    //   var snippet = ''
    //   if (block.params) {
    //     let params = {}
    //     for (let i = 0; i < block.params.length; i++) {
    //       params[block.params[i].name] = block.params[i].value
    //     }
    //     snippet = store.interpolate(block.code)(params)
    //   } else {
    //     snippet = block.code
    //   }
    //   return snippet
    // },
    destinationListBlockHeaders() {
      var headers = [{'text': 'Create and run source block first', value: 'createSourceBlock'}]
      try {
        headers = this.storeState.blocks[this.storeState.block.destination.emailSourceBlock.uuid].results.headers
      } catch (error) {
        console.error('no storeState.block.destination.emailSourceBlock.uuid')
      }
      return headers
    },
    triggerBlockHeaders() {
      var headers = []
      if (this.storeState.block.trigger.blockId) {
        try {
          headers = this.storeState.blocks[this.storeState.block.trigger.blockId].results.headers
        } catch (error) {
          console.error('no triggerBlockHeaders')
        }
      }
      return headers
    },
    triggerBlockList() {
      if (Object.keys(this.storeState.blocks).length === 0) return []
      let blockList = []
      for (let [key, obj] of Object.entries(this.storeState.blocks)) {
        if (obj.cellType != 'json' && obj.cellType != 'set' && 
            obj.cellType != 'snippet' && obj.uuid != this.storeState.block.uuid) {
          if ((obj.cellType === 'sql' || obj.cellType === 'sheetsAsSql') && obj.code.length > 0 && 
                obj.title.length > 0 && obj.results.rows && 
                (obj.results.rows.length == 1 || this.storeState.block.trigger.type === 'hasRows')) {
            blockList.push({uuid: obj.uuid, title: obj.title, viewedOn: obj.viewedOn})
          }
        }
      }
      return blockList.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    blockList() {
      if (Object.keys(this.storeState.blocks).length === 0) return []
      let blockList = []
      for (let [key, obj] of Object.entries(this.storeState.blocks)) {
        if (obj.cellType != 'json' && obj.cellType != 'set' && obj.cellType != 'snippet') {
          if (['sql', 'sheetsAsSql', 'python'].includes(obj.cellType) && obj.code.length > 0 && obj.title.length > 0) {
            blockList.push({uuid: obj.uuid, title: obj.title, viewedOn: obj.viewedOn})
          } else if (['doc'].includes(obj.cellType) && obj.title.length > 0) {
            blockList.push({uuid: obj.uuid, title: obj.title, viewedOn: obj.viewedOn})
          }
        }
      }
      return blockList.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    cmAutofocus: function () {
      return storeState.cmAutofocus
    },
    uniqueSources: function () {
      let result = []
      let uniqueNickNames = []
      if (this.storeState.block.source.uuid) {
        let curS = this.storeState.allSources.find(o => o.block_uuid === this.storeState.block.source.uuid)
        if (curS) {
          result.push(curS)
          uniqueNickNames.push(curS.name)
        }
      }
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name)) {
          uniqueNickNames.push(source.name)
          result.push(source)
        }
      }
      // result = result.concat(this.storeState.sets)
      return result
    },
    dbDestinations: function () {
      let result = []
      let uniqueNickNames = []
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name) && !['airtable', 'sfdc', 'SQLite3'].includes(source.db_type)) {
          uniqueNickNames.push(source.name)
          result.push(source)
        }
      }
      // result = result.concat(this.storeState.sets)
      return result
    },
    dbTables: function () {
      return this.storeState.dbMeta.tables
    },
    dbPrimaryKeys: function () {
      console.log('dbPrimaryKeys: ', this.storeState.block.destination)
      if (this.storeState.dbMeta && this.storeState.block.destination.table) {
        console.log('dbPrimaryKeys: ', this.storeState.block.destination.table)
        // let schemaName = this.storeState.block.destination.table.split('.')[0]
        // let table = schema[this.storeState.block.destination.table.split('.')[1]]
        let rows = this.storeState.dbMeta.df.filter(row => `${row.table_schema}.${row.table_name}` === this.storeState.block.destination.table)
        // let columns = row.map(row => row.column_name)
        return rows.map(row => row.column_name)
      }
      return []
    },
    portHint: function () {
      let hint = this.dbTypes.find(d => d.key === this.newSource.db_type).portHint
      return hint || ''
    },
    runTimes: function () {
      let mins = _.range(0, 59, 5)
      let hours = _.range(0, 23, 1)
      let times = []

      for (let i = 0; i < hours.length; i++) {
        let hour = hours[i];
        for (let i = 0; i < mins.length; i++) {
          times.push(`${_.padStart(hour, 2, '0')}:${_.padStart(mins[i], 2, '0')}`)
        }
      }
      return times
    }
  },
  components: {
    codemirror,
    LineChart,
    BarChart,
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
  },
  watch: {
    'storeState.blockListOpen': {
        handler: function (val, oldVal) {
          this.hoverBlock = false
        },
        deep: false
    },
    newSource: {
        handler: function (val, oldVal) {
          // this.$route.params.id = val
        },
        deep: true,
    },
    
    'storeState.gotBlock': {
        handler: function (val, oldVal) {
          if (this.storeState.blockHistory.length === 0) this.getBlockHistory()
        },
        deep: false
    },
    'newSource.authenticator': {
        handler: function (val, oldVal) {
          if (val && val.toUpperCase() === 'SNOWFLAKE_JWT') {
            this.newSource.ssh = true            
          }
        },
        deep: false
    },
    'storeState.block.pivot': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.story': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.viz.chartJsOptions.legend': {
      handler: function (newVal, oldVal) {
        console.log('watch chart options', 'newval: ', newVal, '   oldVal:', oldVal)
        setTimeout(() => {
          // this.makeChart()
        }, 0);
      },
      deep: true,
    },
    'storeState.block.manualDestination': {
      handler: function (newVal, oldVal) {
        store.updateBlock({gotBlock: this.storeState.gotBlock})
      },
      deep: true,
    },
    'storeState.block.viz.title': {
      handler: function (newVal, oldVal) {
        store.updateBlock({gotBlock: this.storeState.gotBlock})
      },
      deep: true,
    },
    'storeState.block.viz.chartJsOptions': {
      handler: function (newVal, oldVal) {
        store.updateBlock({gotBlock: this.storeState.gotBlock})
      },
      deep: true,
    },
    'storeState.block.viz.type': {
      handler: function (newVal, oldVal) {
        store.updateBlock({gotBlock: this.storeState.gotBlock})
      },
      deep: false,
    },
    'appendReplace': {
      handler: function (newVal, oldVal) {
        console.log('watch appendReplace ', 'newval: ', newVal, '   oldVal:', oldVal)
        this.storeState.block.destination.sheetsAppend = newVal === 'append'
      },
      deep: false,
    },
    'storeState.block.repeat.period': {
        handler: function (val, oldVal) {
          console.log('storeState.block.repeat.period: ', val, oldVal)
        },
        deep: true,
    },
    'storeState.block.trigger': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true,
    },
    'storeState.block.setQuery': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: false
    },
    'storeState.block.results.headers': {
        handler: function (val, oldVal) {
          if (val.length > 0) this.updateSetSchemaAfterRun()
        },
        deep: true,
    },
    'storeState.block.browsing.headers': {
        handler: function (val, oldVal) {
          console.log('storeState.block.browsing.headers: ', val, oldVal)
        },
        deep: true,
    },
    'storeState.block.tags': {
        handler: function (val, oldVal) {
          console.log('storeState.block.tags: ', val, oldVal)
          var tags = []
          tags.push(this.storeState.setTag)
          tags.push(this.storeState.formTag)
          for (let [key, value] of Object.entries(this.storeState.blocks)) {
            let blockTagKeys = value.tags.map(t => t.value)
            let allTagKeys = tags.map(t => t.value)
            let newTags = _.difference(blockTagKeys, allTagKeys)
            if (newTags.length > 0 && newTags[0]) {
              for (let i = 0; i < newTags.length; i++) {
                tags.push(value.tags.find(t => t.value === newTags[i]))
              }
            }
          }
          // let setTag = tags.find(t => t.text === 'Set')
          // if (!setTag) tags.push(this.storeState.setTag)
          this.storeState.blockTags = tags
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          this.$forceUpdate()
          store.updateTagList()
          this.$forceUpdate()
        },
        deep: true,
    },
    'storeState.block.code': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (['sql', 'airtableAsSql', 'snippet'].includes(this.storeState.block.cellType)) store.updateAst()          
        },
        deep: true
    },
    'storeState.block.cellType': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.set && this.storeState.block.set.type === 'json') {
            this.showSuggestions = false
            this.storeState.block.cellType = 'json'
          } else if (val === 'python') {
            this.cmOptions.mode = 'text/x-python'
          }
        },
        deep: true
    },
    'storeState.block.title': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          }
        },
        deep: false
    },
    'storeState.block.destination': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.source': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          // if (this.storeState.block.cellType === 'snippet') {
          //   // dont change
          // } else if (val.type === 'airtable' || val.db_type === 'airtable') {
          //   this.storeState.block.cellType = 'airtableAsSql'
          // } else if (val.type === 'sheets' || val.uuid === 'googlesheets') {
          //   this.storeState.block.cellType = 'sheetsAsSql'
          // } else {
          //   this.storeState.block.cellType = 'sql'
          // }
        },
        deep: true
    },
    'storeState.block.repeat': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.favorite': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.params': {
        handler: function (val, oldVal) {
          console.log('storeState.block.params updated')
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          for (let index = 0; index < this.storeState.block.params.length; index++) {
            const param = this.storeState.block.params[index];
            if (param.type === 'sheets' && param.sheet && param.sheet.length === 0) {
              this.storeState.paramError = 'You need to add a Sheet name'
            } else if (param.type === 'sheets') {
              this.storeState.paramError = false
            }
            // } else if (param.type === 'select' && param.column) {
              // param.options = this.storeState.blocks[param.blockId] param.column
              // param.options = this.storeState.blocks[param.blockId].results.rows.map(row => row[param.column])
            // }
          }
          if (this.storeState.block.cellType === 'snippet') {
            this.renderSnippet()
          }
        },
        deep: true
    },
    'storeState.tableLoading': {
        handler: function (val, oldVal) {
          console.log('tableLoading 1', 'newval: ', val, '   oldVal:', oldVal)
        },
        deep: true
    },
    '$route.params.id': function (newId, oldId) {
      console.log('uuid changed', newId, oldId)
      this.getBlock(newId)
    },
    'storeState.block.source.uuid': {
        handler: function (newId, oldId) {
          if (!newId || newId === oldId) return
          if (newId === 'sfdc') {
            this.storeState.block.source.name = 'Salesforce'
            this.storeState.browsing.active = 'tables'
            // this.storeState.block.source.type = 'airtable'
            this.storeState.block.source.db_type = 'sfdc'
            this.cmOptions.mode = 'text/x-mysql'
            this.storeState.dbMeta = false
            //TODO add get airtable schema
            return
          }
          let u = this.storeState.allSources.find(s => s.block_uuid === newId)
          let old = this.storeState.allSources.find(s => s.block_uuid === oldId)
          if (u && u.type === 'sheets') {
            this.storeState.block.cellType = 'sheetsAsSql'
            return
          } else if (u && u.db_type === 'airtable') {
            this.storeState.block.cellType = 'airtableAsSql'
            this.storeState.block.source.name = u.text || u.name
            this.storeState.block.source.type = 'airtable'
            this.storeState.block.source.db_type = 'airtable'
            this.cmOptions.mode = 'text/x-mysql'
            this.storeState.dbMeta = false
            //TODO add get airtable schema
            return
          } else if (u && u.db_type === 'sfdc') {
            this.storeState.block.source.name = 'Salesforce'
            this.storeState.browsing.active = 'tables'
            // this.storeState.block.source.type = 'airtable'
            this.storeState.block.source.db_type = 'sfdc'
            this.cmOptions.mode = 'text/x-mysql'
            this.storeState.dbMeta = false
            //TODO add get airtable schema
            return
          } else if (u && u.name) {
            if (old && u.name === old.name) return
            this.storeState.block.source.name = u.text || u.name
            if (this.storeState.block.cellType != 'snippet') this.storeState.block.cellType = 'sql'
            this.cmOptions.mode = 'text/x-mysql'
            this.storeState.block.source.db_type = u.db_type
            this.storeState.dbMeta = false
            if (u.db_type != 'bigquery') {
              this.getExplore(this)
            }

            return
          } else {
            this.storeState.browsing.active = 'schema'
            var set = this.storeState.sets.find(s => s.block_uuid === newId)
          }
          if (set) {
            console.log('selected model', set)
            this.storeState.block.source.name = set.name
            this.storeState.block.source.uuid = set.block_uuid
            this.storeState.block.cellType = 'set'
            this.cmOptions.mode = 'javascript'
            if (this.storeState.block.code.length < 3) {
              Object.entries(this.storeState.blocks).forEach(([key, value]) => {
                if (key === set.block_uuid) {
                  var j = {}
                  for (let i = 0; i < value.results.headers.length; i++) {
                    let el = value.results.headers[i];
                    console.log(el)
                    j[el.value] = {
                      label: this.makeLabel(el.value),
                      type: this.getSetColType(el),
                    }
                  }
                  j['count'] = {
                    "label": "Count",
                    "measure": true,
                    "type": "count"
                  }
                  j = {fields: j, filters: {}}
                  j = JSON.stringify(j, null, '\t')
                  this.storeState.block.code = j
                  console.log('modelBlock', value)
                }
              })
            }
            return
          }
          setTimeout(() => {
            this.$forceUpdate()
          }, 0);
          let source = this.storeState.sources.find(s => s.block_uuid === newId)
          // if (source && source.meta) this.storeState.dbMeta = source.meta
          if (source && source.name) this.storeState.block.source.name = source.name
        },
        deep: true
    },
    'storeState.sources': {
        handler: function (newVal, oldVal) {
          if (this.storeState.block.source && this.storeState.block.source.uuid) {
            let source = this.storeState.sources.find(s => s.block_uuid === this.storeState.block.source.uuid)
            if (source && source.meta) this.storeState.dbMeta = source.meta
          }
        },
        deep: true
    },
    // 'storeState.block.results.rows': {
    //     handler: function (val, oldVal) {
    //       if (this.storeState.block && this.storeState.block.results.rows.length > 0) {
    //         store.updateBlock({gotBlock: this.storeState.gotBlock})
    //         this.makeChart()
    //       }
    //     },
    //     deep: true
    // },
    // 'storeState.block.viz': {
    //     handler: function (val, oldVal) {
    //       store.updateBlock({gotBlock: this.storeState.gotBlock})
    //     },
    //     deep: true
    // },
  },
  methods: {
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    refreshTse() {
      window.parent.postMessage(
        {
            sender: "seekwell",
            data: {loaded: true}
        },
        "*"
      )
    },
    embedDestination() {
      this.onlyDestination = true
    },
    clearEditables() {
      Vue.set(this.storeState.block.editables, 'pending', {})
    },
    updateEditable(blockId, column, row, rowNum) {
      console.log('updateEditable: ', row)
      let param = this.storeState.block.params.find(p => p.type === 'editable' && column === p.name)
      var rowUpdates = {}
      let key = `${rowNum}-${column}`
      if (this.storeState.block.editables.pending[key]) {
        rowUpdates = this.storeState.block.editables.pending[key]
      }
      rowUpdates[key] = {row: row, param: param}
      Vue.set(this.storeState.block.editables.pending, key, rowUpdates)
    },
    runEditableBlocks(blockId) {
      var blockId = this.storeState.block.uuid
      for (let [key, obj] of Object.entries(this.storeState.block.editables.pending)) {
        // this.storeState.block.editables.running[key] = JSON.parse(JSON.stringify(obj))
        this.runEditableBlock(obj[key])
      }
      Vue.set(this.storeState.block.editables, 'pending', {})
    },
    runEditableBlock(opts) {
      if (opts.param && !opts.param.updateWithBlock) {
        this.storeState.snackbar = true;
        this.storeState.message = `You need to set the block for ${opts.param.name}`;
        return
      } 
      let block = store.makeBlockSafe(this.storeState.blocks[opts.param.updateWithBlock])
      for (let index = 0; index < block.params.length; index++) {
        const param = block.params[index];
        if (param.type && param.type === 'value' && param.name in opts.row) {
          param.value = opts.row[param.name]
        }
      }
      let runId = store.uuidv4()
      let sub = {
        params: block.params,
        user: this.storeState.settings.user.me.email,
        date: moment.unix(moment()).utc()._i,
        statusChanged: moment.unix(moment()).utc()._i,
        status: 'approved',
        edit: false,
        uuid: runId,
      }
      this.storeState.runningNowIds.push({runId: runId, blockId: block.uuid})
      store.runTempBlock(block, {
          runId: runId,
        }
      )
    },
    openParamsDocs() {
      let url = 'https://www.notion.so/Parameters-e18b84a0e07d42ba981a449e2e53f018'
      var win = window.open(url, '_blank');      
    },
    drillDown(col, row) {
      console.log('drillDown: ', col)
      let drill = this.storeState.block.params.find(p => p.name === col)
      if (drill.drillToBlock) {
        let drillToBlock = this.storeState.blocks[drill.drillToBlock]
        let q = { runOnLoad: 1 }
        q[drill.name] = row[col]
        if (drillToBlock.cellType === 'doc') {
          this.$router.push(
            { 
              name: 'Docs', 
              params: {id: drill.drillToBlock }, 
              query: q
            }
          ).catch(err => console.error(err))
        } else {
          this.$router.push(
            { 
              name: 'Run', 
              params: {id: drill.drillToBlock }, 
              query: q
            }
          ).catch(err => console.error(err))
        }
        
      }
    },
    addParameter() {
      let p = {name: '', value: '', type: 'thoughtspot'}
      this.storeState.block.params.push(p)
      this.editParams = true
    },
    deleteParam(param, index) {
      this.storeState.block.params.splice(index, 1)
    },
    setBlockHistoryHover(index, blockId) {
      this.blockHistoryHover = index
      this.hoverBlock = this.storeState.blocks[blockId]
    },
    addLookup() {
      this.addingLookup = true
      // let lookup = this.storeState.block.params.filter(p => p.type === 'lookup')
      // if (lookup.length)
      this.storeState.block.params.push({
        type: 'lookup',
        name: 'lookup'
      })
    },
    renderSnippet() {
      console.log('renderSnippet...')
      let block = this.storeState.block
      var snippet = ''
      if (block.params) {
        let params = {}
        for (let i = 0; i < block.params.length; i++) {
          params[block.params[i].name] = block.params[i].value
        }
        snippet = store.interpolate(block.code)(params)
      } else {
        snippet = block.code
      }
      this.renderedSnippet = snippet
    },
    newWindow(blockId) {
      console.log('newWindow: ', blockId)
      this.storeState.blockListOpen = false
      this.blockHistoryHover = -1
      if (!blockId) {
        blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        store.saveToLocalStorage('seekwell_newBlockId', blockId)
      }
      let routeData = this.$router.resolve({ name: 'Run', params: {id:  blockId}});
      window.open(routeData.href, '_blank');
      this.storeState.cmdkActive = false
    },
    onNewParamBlock(param, index) {
      this.paramColumnSearches[index] = ''
      // param.value = ''
      // param.column = 'blah'
      // Vue.set(this.storeState.block.params, index, param)
    },
    runLookUpBlock(param, index) {
      // if (param.column && param.blockId) {
      //   this.storeState.block.params[index].options = this.storeState.blocks[param.blockId].results.rows.map(row => row[param.column])
      // }
    },
    updateSelectOptions(param, index) {
      if (param.column && param.blockId) {
        this.storeState.block.params[index].options = this.storeState.blocks[param.blockId].results.rows.map(row => row[param.column])
      }
    },
    getBlockParams(blockId) {
      var params = []
      if (blockId && this.storeState.blocks[blockId] && this.storeState.blocks[blockId].params) {
        params = this.storeState.blocks[blockId].params.map(function(elem) {
          return {
            name: elem.name,
            value: elem.name,
          } 
        });
      }
      return params
    },
    getBlockHeaders(blockId) {
      var headers = []
      if (blockId && this.storeState.blocks[blockId] && this.storeState.blocks[blockId].results &&
          this.storeState.blocks[blockId].results.headers) {
            headers = this.storeState.blocks[blockId].results.headers
          }
      return headers
    },
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu() {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl(command, url) {
      command({ href: url })
      this.hideLinkMenu()
    },
    upgrade() {
      this.$parent.upgrade()
    },
    getBlockHistory(uuid) {
      if (!this.storeState.blocks) return []
      if (Object.keys(this.storeState.blocks).length === 0) return []
      let blockList = []
      for (let [key, obj] of Object.entries(this.storeState.blocks)) {
        if (['sql', 'story', 'sheetsAsSql', 'python', 'snippet'].includes(obj.cellType) &&
              (obj.code.length > 0 || obj.title.length > 0)) {
          var meta = false
          if (obj.results && obj.results.meta) meta = obj.results.meta
          blockList.push({uuid: obj.uuid, title: obj.title, viewedOn: obj.viewedOn, meta: meta})
        }
      }
      this.storeState.blockHistory = blockList.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 100)
      if (uuid) {
        let idx = this.storeState.blockHistory.findIndex(b => b.uuid === uuid)
        if (idx >= 0) this.storeState.blockHistoryPosition = idx
      } else {
        this.storeState.blockHistoryPosition = -1
      }
      console.log('getBlockHistory: ', this.storeState.blockHistoryPosition)
    },
    openBlock(uuid) {
      this.storeState.blockListOpen = false
      this.blockHistoryHover = -1
      this.$parent.openBlock(uuid)
    },
    addTrigger() {
      this.addingTrigger = true
    },
    elementFromString(value) {
      const element = document.createElement('div')
      element.innerHTML = value.trim()

      return element
    },
    insertHTML({ state, view }, value) {
      // https://github.com/scrumpy/tiptap/issues/385
      const { selection } = state
      const element = this.elementFromString(value)
      const slice = DOMParser.fromSchema(state.schema).parseSlice(element)
      const transaction = state.tr.insert(selection.anchor, slice.content)
      view.dispatch(transaction)
    },
    viewStoryDocs() {
      let e = this.storeState.dbError
      let url = `https://www.notion.so/Stories-d4dcb303d28b400492741b5741fc2f86`
      var win = window.open(url, '_blank');
      win.focus();
    },
    googleDbError() {
      let e = this.storeState.dbError
      let url = `https://www.google.com/search?q=${e}`
      var win = window.open(url, '_blank');
      win.focus();
    },
    ioSplitDown() {
      this.storeState.viewNumber = 2
    },
    ioSplitUp() {
      if (this.storeState.viewNumber === 2) {
        this.storeState.viewNumber = 1
      } else if (this.storeState.viewNumber === 3) {
        this.storeState.viewNumber = 1
      } else {
        this.storeState.viewNumber = 3
      }
    },
    goBackInBrowseSfdc() {
      this.storeState.browsing.search = ''
      if (this.storeState.browsing.active === 'tables') {
        return
      } else if (this.storeState.browsing.active === 'columns') {
        this.storeState.browsing.active = 'tables'
      } else {
        this.storeState.browsing.active = 'columns'
      }
    },
    goBackInBrowse() {
      this.storeState.browsing.search = ''
      if (this.storeState.browsing.active === 'schemas') {
        return
      } else if (this.storeState.browsing.active === 'tables') {
        this.storeState.browsing.active = 'schemas'
      } else if (this.storeState.browsing.active === 'columns') {
        this.storeState.browsing.active = 'tables'
      } else {
        this.storeState.browsing.active = 'columns'
      }
    },
    // toggleSchemaShowTables(index) {
    //   // Vue.set(this.storeState.dbMeta.schemas[index], 'showTables', true)
    //   let s = this.storeState.dbMeta.schemas[index]
    //   s.showMore = !s.showMore
    //   this.$set(this.storeState.dbMeta.schemas, index, s)
    // },
    goToSchemaTables(schema) {
      this.storeState.browsing.search = ''
      this.storeState.browsing.active = 'tables'
      this.storeState.browsing.schema = schema
    },
    goToSchemaColumnsSfdc(table) {
      this.storeState.browsing.search = ''
      this.storeState.browsing.active = 'columns'
      this.storeState.browsing.table = table
      var table = this.storeState.browsing.table
      // if (this.storeState.browsing.schema) table = `${this.storeState.browsing.schema}.${table}`
      // let block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
      // block.uuid = store.uuidv4()
      // block.source.uuid = this.storeState.block.source.uuid
      // let source = this.storeState.allSources.find(s => s.block_uuid === this.storeState.block.source.uuid)
      // let sql = store.generateTopTenSql({table: table, db_type: source.db_type})
      // block.code = sql
      // store.runSchemaInfo(block, {type: 'topTen'})
    },
    goToSchemaColumns(table) {
      this.storeState.browsing.search = ''
      this.storeState.browsing.active = 'columns'
      this.storeState.browsing.table = table
      var table = this.storeState.browsing.table
      if (this.storeState.browsing.schema) table = `${this.storeState.browsing.schema}.${table}`
      let block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
      block.uuid = store.uuidv4()
      block.source.uuid = this.storeState.block.source.uuid
      let source = this.storeState.allSources.find(s => s.block_uuid === this.storeState.block.source.uuid)
      let sql = store.generateTopTenSql({table: table, db_type: source.db_type})
      block.code = sql
      store.runSchemaInfo(block, {type: 'topTen'})
    },
    getColumnDetails(column) {
      console.log('getColumnDetails: ', column)
      var table = this.storeState.browsing.table
      if (this.storeState.browsing.schema) table = `${this.storeState.browsing.schema}.${table}`
      let sql = store.generateStatsSql({column: column, table: table})
      let block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
      block.uuid = store.uuidv4()
      block.code = sql
      block.source.uuid = this.storeState.block.source.uuid
      store.runSchemaInfo(block, {type: 'columnDetails'})
      this.storeState.browsing.active = 'columnDetails'
    },
    goToSearch() {
      this.storeState.searchIndex = 0
      this.storeState.searchTerm = this.storeState.browsing.search
      this.storeState.searching = true
      this.$router.push({ name: 'Search'}).catch(err => console.error(err))
    },
    sendToDev() {
      this.storeState.cmdkActive = true
      this.storeState.cmdkParentCmd = 'sendInvite'
    },
    goToDocumentation() {
      let url = `https://www.notion.so/Knowledge-Base-7e6abd7243ca43ad863372a264c44452#14f7e04710674225bed65d97d05715e7`
      var win = window.open(url, '_blank');
    },
    resizeOutput() {
      setTimeout(() => {
        
      }, 50);
    },
    hideFilters() {
      this.showFilters = false
    },
    addFilter() {
      let filter = {
        andOr: false,
        field: '',
        operator: '=',
        value: '',
      }
      if (this.storeState.block.set.filters.length > 0) {
        filter.andOr = 'and'
      }
      this.storeState.block.set.filters.push(filter)
    },
    removeFilter(index) {
      this.storeState.block.set.filters.splice(index, 1)
      this.showFilters = true
    },
    makeChart() {
      console.log('make chart')
      if (!this.storeState.allRows) {
        store.runCode({})
        return
      }
      this.chartReady = false
      let dm = this.getDimensionsMeasures(this.storeState.allRows)
      if (dm.dimensions.length === 0) return
      this.storeState.block.viz.datacollection = {
        labels: this.getChartLabels(this.storeState.allRows, dm),
        datasets: this.getChartData(this.storeState.allRows, dm),
      }
      this.chartReady = true
    },
    flipStacked() {
      this.storeState.block.viz.stacked = !this.storeState.block.viz.stacked
      if (this.storeState.block.viz.stacked) {
        this.storeState.block.viz.chartJsOptions.scales = {
          xAxes: [{
              stacked: true
          }],
          yAxes: [{
              stacked: true
          }]
        }
      } else {
        this.storeState.block.viz.chartJsOptions.scales = {}
      }
      // this.$forceUpdate()
      this.makeChart()
    },
    flipFill() {
      this.storeState.block.viz.fill = !this.storeState.block.viz.fill
      // this.$forceUpdate()
      this.makeChart()
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getTypeIcon(row) {
      if (row.measure) return 'mdi-numeric'
      if (!row.type) return 'mdi-format-text'
      return this.storeState.iconLookUp[row.type]
    },
    vizRowClick(row) {
      let changed = this.storeState.block.setQueryThings.findIndex(q => q.suggestionUuid === row.suggestionUuid)
      this.storeState.block.setQueryThings[changed].selected = !this.storeState.block.setQueryThings[changed].selected
      this.makeChart()
      this.$forceUpdate()
    },
    showFiltersNow()  {
      this.showFilters = !this.showFilters
      this.getFilterSuggestions()
      this.getFilterOperators()
      this.$forceUpdate()
    },
    showTableNow() {
      this.storeState.viewNumber = 1
      this.showTable = true
      this.showChart = false
      this.showSnippet = false
    },
    showChartNow() {
      this.storeState.viewNumber = 1
      this.showTable = false
      this.showChart = true
      this.makeChart()
    },
    showHtmlNow() {
      this.storeState.viewNumber = 1
    },
    showBrowseNow() {
      this.storeState.viewNumber = 5
      this.showTable = false
      this.showChart = false
    },
    showSnippetNow() {
      this.storeState.viewNumber = 1
      this.showTable = false
      this.showChart = false
      this.showSnippet = true
    },
    getAllFieldsForSet(setBlockId) {
      var self = this
      let set = this.storeState.blocks[setBlockId]
      var setFields = JSON.parse(set.code).fields
      let fields = []
      let index = 0
      var firstMeasure = false
      var firstDimension = false
      for (let [key, value] of Object.entries(setFields)) {
        let f = value
        f.path = `${set.name}.${key}`
        f.name = `${value.name || key}`
        f.uuid = set.block_uuid
        f.setJsonId = set.setJsonId
        f.suggestionUuid = store.uuidv4()
        f.setType = 'field'
        f.selected = false
        if (!firstMeasure && f.measure) {
          firstMeasure = true
          f.selected = true
        }
        if (!firstDimension && f.dimension) {
          firstDimension = true
          f.selected = true
        }
        fields.push(f)
        index+=1
      }
      if (fields.length > 0) fields[0].selected = true
      // storeState.block.setQueryThings.filter(t => (!t.measure && t.label))
      return fields
    },
    getDimensionsMeasures(d) {
      let dimensions = []
      let measures = []
      if (this.storeState.block.setQueryThings.length === 1) {
        var allFields = this.getAllFieldsForSet(this.storeState.block.setQueryThings[0])
        this.storeState.block.setQueryThings = [...allFields, ...this.storeState.block.setQueryThings]
      }
      for (let i = 0; i < this.storeState.block.setQueryThings.length; i++) {
      // for (let [key, obj] of Object.entries(d[0])) {
        // let setInfo = this.storeState.block.setQueryThings.find(t => t.label === key || t.name === key)
        let setInfo = this.storeState.block.setQueryThings[i]
        if (!setInfo) {
          //do nothing
        } else if (setInfo.measure) {
          console.log('found measure: ', setInfo)
          setInfo.data = []
          measures.push(setInfo)
        } else {
          dimensions.push(setInfo)
        }
      }
      return {dimensions: dimensions, measures: measures}
    },
    getChartLabels(d, dm) {
      let rows = []
      let dim = dm.dimensions.filter(o => o.selected)[0]
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        let val = row[dim.label] || row[dim.name]
        rows.push(val)
      }
      return rows
    },
    getChartData(d, dm) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        // dm.measures[i].data = []
        for (let i2 = 0; i2 < dm.measures.length; i2++) {
          let val = row[dm.measures[i2].label] || row[dm.measures[i2].name]
          dm.measures[i2].data.push(val)
        }
      }
      for (let i = 0; i < dm.measures.length; i++) {
        let el = dm.measures[i];
        if (el.selected) {
          var color = this.defaultColorScheme[i].color
          if (!color) color = this.getRandomColor()
          rows.push({
            label: el.label,
            backgroundColor: color,
            borderColor: color,
            data: el.data,
            fill: this.storeState.block.viz.fill
          })
        }
      }
      return rows
    },
    getFilterSuggestions() {
      this.filterSuggestions = []
      let numPerCategory = 3
      let sets = []
      let fields = []
      var uniqueSetsInSearch = []
      if (this.storeState.block.setQueryThings.length > 0) {
        var uniqueSetsInSearch = _.uniq(_.map(this.storeState.block.setQueryThings, 'set'));
        for (let i = 0; i < this.storeState.block.setQueryThings.length; i++) {
          let thing = this.storeState.block.setQueryThings[i];
          uniqueSetsInSearch.push(thing.set || thing.name)
        }
        uniqueSetsInSearch = _.uniq(uniqueSetsInSearch);
      }
      for (let i = 0; i < this.storeState.sets.length; i++) {
        let set = this.storeState.sets[i];
        if (uniqueSetsInSearch.length > 0 && !uniqueSetsInSearch.includes(set.name)) continue 
        let jsonValid = false
        try {
          JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
          jsonValid = true
        } catch (error) {
          jsonValid = false
        }
        if (!set.setJsonId || !jsonValid) {
          continue
        }
        var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
        for (let [key, value] of Object.entries(setFields)) {
          let f = value
          f.path = `${set.name}.${key}`
          f.name = `${key}`
          f.uuid = set.block_uuid
          f.setJsonId = set.setJsonId
          f.suggestionUuid = store.uuidv4()
          f.setType = 'field'
          fields.push(f)
        }
      }
      let fields2 = []
      for (let i2 = 0; i2 < fields.length; i2++) {
        let field = fields[i2];
        let match = {include: true, ratio: 1}
        if (match.include && !field.measure) {
          field.title = field.label || field.name
          field.details = `${field.type} in ${field.path}`
          field.ratio = match.ratio
          field.icon = this.storeState.iconLookUp[field.type]
          field.setType = 'field'
          this.filterSuggestions.push(field)
        }
      }
      this.filterSuggestions = this.filterSuggestions.sort((a, b) => b.ratio - a.ratio);
    },
    showFiltersNow()  {
      this.showFilters = !this.showFilters
      this.getFilterSuggestions()
      this.getFilterOperators()
      this.$forceUpdate()
    },
    applyFilters() {
      // let sql = store.generateSetSql(this.storeState.block.tables)
      let opts = {setQueryThings: this.storeState.block.setQueryThings, filters: this.storeState.block.set.filters}
      let sql = store.generateSetSql(opts)
      this.storeState.block.code = sql
      this.showSuggestions = false
      this.showFilters = false
      this.storeState.searchSuggestions = []
      store.runSet({})
    },
    onFilterFieldChange() {
      this.getFilterOperators()
    },
    onFilterOperatorChange() {
    },
    getFilterOperators() {
      console.log('getFilterOperators...')
      if (!this.storeState.block.tables) return
      this.tableFilterOperators = []
      for (let i = 0; i < this.storeState.block.set.filters.length; i++) {
        let filter = this.storeState.block.set.filters[i];
        if (!filter.field.type) {
          this.tableFilterOperators[i] = this.filterOperators['string']
        } else {
          this.tableFilterOperators[i] = this.filterOperators[filter.field.type]
        }
      }
      this.$forceUpdate()
    },
    customDataNlpAutoFilter() {
      return true
    },
    getDateNlpSuggestions(index) {
      console.log('getDateNlpSuggestions...')
      let filters = this.storeState.block.set.filters[index]
      var opt = {text: `e.g. "3 days ago"`, value: 'asdfasdf'}
      var parsedDate = chrono.parseDate(this.dateNlpSearch)
      if (parsedDate) {
        console.log('getDateNlpSuggestions...', parsedDate, parsedDate.toDateString())
        let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
        opt = {text: sqlDate, value: sqlDate}
        filters.dateNlpSuggestions = [opt]
        this.$set(this.storeState.block.set.filters, index, filters)
      } else {
        filters.dateNlpSuggestions = []
        let periods = ['days', 'weeks', 'months', 'years', 'hours', 'minutes']
        let exacts = ['yesterday', 'tomorrow', 'today', 'now', 'monday', 'tuesday']
        var includePeriods = []
        let searchParts = this.dateNlpSearch.split(' ')
        let nums = this.dateNlpSearch.match(/(\d+)/)
        var num = 1
        if (nums) num = nums[0]
        var hasYesteday = false
        var hasToday = false
        for (let i = 0; i < searchParts.length; i++) {
          let search = searchParts[i];
          for (let i2 = 0; i2 < periods.length; i2++) {
            let period = periods[i2];
            if (period.startsWith(search)) {
              let p = `${num} ${period} ago`
              var parsedDate = chrono.parseDate(p)
              if (parsedDate) {
                let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
                opt = {text: p, value: sqlDate}
                filters.dateNlpSuggestions.push(opt)
              }
            }
          }
          for (let i2 = 0; i2 < exacts.length; i2++) {
            let exact = exacts[i2];
            if (exact.startsWith(search)) {
              var parsedDate = chrono.parseDate(exact)
              let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
              opt = {text: exact, value: sqlDate}
              filters.dateNlpSuggestions.push(opt)
            }
          }
        }
        this.$set(this.storeState.block.set.filters, index, filters)
      }
    },
    getDatePeriodSuggestions(index) {
      console.log('getDatePeriodSuggestions...')
      let filters = this.storeState.block.set.filters[index]
      filters.dateNlpSuggestions = []
      let periods = ['days', 'months', 'years', 'hours', 'minutes']
      var includePeriods = []
      let searchParts = this.dateNlpSearch.split(' ')
      let nums = this.dateNlpSearch.match(/(\d+)/)
      var num = 1
      if (nums) num = nums[0]
      for (let i = 0; i < periods.length; i++) {
        let period = periods[i];
        for (let i2 = 0; i2 < searchParts.length; i2++) {
          let search = searchParts[i2];
          if (period.startsWith(search)) {
            includePeriods.push(period)
          }
        }
      }
      if (includePeriods.length === 0) includePeriods = periods
      for (let i = 0; i < includePeriods.length; i++) {
        let period = includePeriods[i];
        let opt = {text: `${num} ${period}`, value: `${num} ${period}`, num: num, period: period}
        filters.dateNlpSuggestions.push(opt)
      }
      this.$set(this.storeState.block.set.filters, index, filters)
    },
    changeSort(column) {
      if (Object.keys(this.storeState.block.editables.pending).length > 0) return
      if (!this.storeState.allRows) {
        store.runCode({})
        return
      }
      if (this.storeState.block.results.tableOptions.sortBy === column) {
        let direction = !this.storeState.block.results.tableOptions.sortDesc
        this.storeState.block.results.tableOptions.sortDesc = direction
        this.storeState.allRows = _.orderBy(this.storeState.allRows, [column], [(direction ? 'desc' : 'asc')]);
      } else {
        this.storeState.block.results.tableOptions.sortBy = column
        this.storeState.block.results.tableOptions.sortDesc = false
        this.storeState.allRows = _.orderBy(this.storeState.allRows, [column], ['asc']);
      }
      this.makeChart()
    },
    showContextMenuHeader(e) {
      e.preventDefault()
      console.log('show context', e)
      this.contextOptions = [
        { title: 'Copy column name', icon: 'mdi-content-copy', f: this.copyColumnName },
        // { title: 'Filter', icon: 'mdi-filter', f: this.addFilterFromHeader },
        { title: 'Hide', icon: 'mdi-eye-off-outline', f: this.hideHeader },
        { title: 'Pivot', icon: 'mdi-subdirectory-arrow-left', f: this.showPivot },
      ]
      if (this.storeState.block.pivot.active) {
        let removePivot = { title: 'Remove Pivot', icon: 'mdi-close', f: this.removePivot }
        this.contextOptions.push(removePivot)
      }
      let headerIndex = e.currentTarget.dataset.headerIndex || e.target.dataset.headerIndex
      let header = this.storeState.block.results.headers[Number(headerIndex)]
      this.contextData.header = header
      this.contextData.x = e.clientX
      this.contextData.y = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    showPivot() {
      this.storeState.block.pivot.active = true
      this.storeState.currentFocus = 'cmdk'
      this.storeState.searchIndex = 0
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = 'pivotTable'
      this.storeState.cmdkInput = ''
      if (!this.storeState.block.pivot.active) {
        this.storeState.block.pivot.active = true
        this.storeState.block.pivot.origHeaders = JSON.parse(JSON.stringify(this.storeState.block.results.headers))
      }
    },
    removePivot() {
      this.storeState.block.pivot.active = false
      this.runCode({})
    },
    copyColumnName() {
      this.$copyText(this.contextData.header.text)
      this.storeState.snackbar = true;
      this.storeState.message = `Copied ${this.contextData.header.text}`;
    },
    addFilterFromHeader() {
      this.addFilter({field: this.contextData.header.text})
      this.showFilters = true
    },
    hideHeader() {
      this.storeState.block.results.headers = this.storeState.block.results.headers.filter(h => h.text != this.contextData.header.text)
    },
    focusMinutesPast() {
      this.showDestination = true
      this.editRepeat = true
      setTimeout(() => {
        this.$refs.minutesPast.focus()
      }, 0);
    },
    scheduleUpdates() {
      this.editRepeat=true
      this.showDestination=true
      setTimeout(() => {
        this.$refs.repeatPeriod.focus()
      }, 0);
    },
    getSetColType(dtype) {
      // https://docs.scipy.org/doc/numpy/reference/arrays.dtypes.html
      // sw data type
      // string, number, boolean and time
      let numpyDtype = {
        '?':	'boolean',
        'b':	'string',
        'B':	'string',
        'i':	'number',
        'u':	'number',
        'f':	'number',
        'c':	'number',
        'm':	'time',
        'M':	'time',
        'O':	'string',
        'U':	'string'
        }
      let type = numpyDtype[dtype.kind]
      if (type) return type
      return 'string'
      // if ()
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    evalSuggestion(suggestion, source) {
      if (suggestion && this.storeState.block.cellType === 'story') {
        let curPos = this.tiptap.state.tr.curSelection.$anchor.pos
        let start = curPos - (this.storeState.searchTerm.length+1)
        const transaction = this.tiptap.state.tr.insertText('', start, curPos)
        this.tiptap.view.dispatch(transaction)
        if (suggestion.type === 'block') {
          let blockToAdd = this.storeState.blocks[suggestion.blockId]
          let headers = blockToAdd.results.headers.slice(0, 20)
          let rows = blockToAdd.results.rows.slice(0, 20)
          var table = `<table class="tw-table-auto" data-block-id="${suggestion.blockId}"><thead><tr>`
          let blockNum = 99 - this.storeState.block.story.blocks.length
          for (let index = 0; index < headers.length; index++) {
            table += `<th class="tw-px-4 tw-py-2">${headers[index].text}</th>`
          }
          table+= `</thead><tbody>`
          for (let index = 0; index < rows.length; index++) {
            const row = rows[index];
            table += `<tr>`
            for (let index2 = 0; index2 < headers.length; index2++) {
              table += `<td data-block-id="12345" style="background-color:rgba(255, 255, 255, .${blockNum});"`
              table += `class="tw-border tw-px-4 tw-py-2">${row[headers[index2].text]}</td>`
            }
            table += `</tr>`
          }
          table += `</tbody></table><br>`
          this.storeState.block.story.blocks.push({blockId: suggestion.blockId, blockNum: blockNum})
          this.insertHTML(this.tiptap, table)
          this.tiptap.focus()
          return
        }
        let node = this.tiptap.schema.nodes.datatag.create({
          uuid: suggestion.uuid, 
          value: suggestion.value,
          blockId: suggestion.blockId,
          title: suggestion.title,
          path: suggestion.path,
        })
        const insertTrans = this.tiptap.state.tr.insert(this.tiptap.state.selection.$anchor.pos, node)
        this.tiptap.view.dispatch(insertTrans)
        this.tiptap.focus()
        // var j = this.tiptap.getJSON()
      } else {
        var cur = editor.getCursor()
        let line = editor.getRange({line: cur.line, ch: 0}, {line: cur.line, ch: cur.ch})
        if (suggestion) {
          var wordRange = editor.findWordAt(cur);
          this.origSearchTerm = editor.getRange(wordRange.anchor, wordRange.head)
          if (this.origSearchTerm == ' ') {
            cur = {line: cur.line, ch: cur.ch-1, sticky: null}
            var wordRange = editor.findWordAt(cur);
            this.origSearchTerm = editor.getRange(wordRange.anchor, wordRange.head)
          }
          let beforeSearch = editor.getRange({line: wordRange.anchor.line, ch: wordRange.anchor.ch-1}, wordRange.anchor)
          store.autoAddSelected(suggestion, this.storeState.searchTerm, wordRange, beforeSearch, line)
        }
      }
    },
    removeTag(item) {
      this.storeState.block.tags.splice(this.storeState.block.tags.indexOf(item), 1)
      this.storeState.block.tags = [...this.storeState.block.tags]
    },
    betterTab(cm) {
      // https://github.com/codemirror/CodeMirror/issues/988
      if (cm.somethingSelected()) {
        cm.indentSelection("add");
      } else {
        let addThis = Array(window.editor.getOption("indentUnit") + 1).join(" ")
        cm.replaceSelection(addThis)
      }
    },
    handleTab() {
      if (this.storeState.showSuggestions) {
        let idx = this.storeState.searchIndex > 0 ? this.storeState.searchIndex : 0
        let suggestion = this.storeState.compositionSuggestions[idx]
        this.evalSuggestion(suggestion, 'tab')
      } else {
        this.betterTab(window.editor)
      }
    },
    handleEnter() {
      if (this.storeState.showSuggestions && this.storeState.searchIndex >= 0 && this.upDownInitiated) {
        let suggestion = this.storeState.compositionSuggestions[this.storeState.searchIndex]
        this.evalSuggestion(suggestion, 'enter')
      } else {
        this.storeState.showSuggestions = false
        window.editor.execCommand("newlineAndIndent")
      }
      this.upDownInitiated = false
    },
    handleDown() {
      this.upDownInitiated = true
      if (!this.storeState.showSuggestions) window.editor.execCommand('goLineDown')
    },
    handleUp() {
      this.upDownInitiated = true
      if (!this.storeState.showSuggestions) window.editor.execCommand('goLineUp')
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    topSuggestion() {
      let idx = this.storeState.searchIndex > 0 ? this.storeState.searchIndex : 0
      let top = this.storeState.compositionSuggestions[idx]
      if (top && this.storeState.searchTerm.length > 0) {
        return ` ⇥ ${top.title}`
      }
      return ''
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      if (!e.currentTarget) return
      let suggestion = this.storeState.compositionSuggestions[e.currentTarget.dataset.index]
      this.evalSuggestion(suggestion, 'click')
    },
    onClick(e) {
      // console.log('click', e, e.target.classList.contains('cm-bracket-sw'))
      if (e.target.classList.contains('cm-bracket-sw')) {
        this.showDestination = true
      }
      // this.storeState.cmdkActive = false;
    },
    getTitle(item) {
      if (!item.title) return 'Untitled'
      if (item.title.length > 10) return item.title.slice(0,10) + '...'
      return item.title
    },
    selectTag(item) {

    },
    makeLabel(s) {
      return s.toLowerCase().split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).toString().replace(',', ' ')
    },
    createTag(tag) {
      console.log(tag)
      // this.storeState.addingTag = true
      // this.storeState.cmdkParentCmd = 'createTag'
      // this.$parent.openCmdK({cmdkParentCmd: 'createTag', cmdkInput: tag})
      let newTag = {
        value: store.uuidv4(),
        text: this.tagInput,
      }
      this.storeState.block.tags.push(newTag)
      setTimeout(() => {
        this.tagInput = ''
      }, 0);
    },
    openCmdKBlank() {
      this.$parent.openCmdK({})
    },
    fromNowFormat: function (data) {
      return moment(data.viewedOn/1000).fromNow()
    },
    fromNowRunFormat: function (data) {
      return moment(data/1000).fromNow()
    },
    clearRepeat() {
      this.editRepeat = false
      this.addingTrigger = false
      this.storeState.block.repeat = JSON.parse(JSON.stringify(this.storeState.blockTemplate.repeat))
      this.storeState.block.trigger = JSON.parse(JSON.stringify(this.storeState.blockTemplate.repeat))
    },
    loadBookFromHistory(uuid) {
      this.$router.push({ name: 'Run', params: {id: uuid }}).catch(err => console.error(err))
      this.getBlock(this.$route.params.id)
    },
    backToSql() {
      this.storeState.block.cellType = 'sql'
    },
    refreshGdWorkbooks() {
      this.loadingWorkbooks = true
      this.$parent.getGoogleDriveWorkbooks()
    },
    refreshSpreadSheets() {
      this.loadingSpreadsheets = true
      this.$parent.getSoupSheets()
    },
    refreshIntercomAttributes() {
      this.$parent.getSoupIntercom()
    },
    refreshBlocks() {
      this.loadingSpreadsheets = true
      this.$parent.getSoupBlocks({rowLimit: this.storeState.maxBlocksToGet})
    },
    newSpreadsheet() {
      // doesnt work for Sheets, only for Docs
      // if (this.searchSpreadsheet && this.searchSpreadsheet.length > 2) {
      //   var link = `https://docs.google.com/spreadsheets/create?title=${this.searchSpreadsheet}`
      // } else if (this.storeState.block.title.length > 0) {
      //   var link = `https://docs.google.com/spreadsheets/create?title=${this.storeState.block.title}`
      // } else {
      //   var link = `https://docs.google.com/spreadsheets/create?title=${'SeekWell Test'}`
      //   this.searchSpreadsheet
      // }
      window.open('https://sheets.new/', '_blank');
    },
    getSqlForSet() {
      let blockId = this.storeState.block.set.sql
      this.$router.push({ name: 'Run', params: {id: blockId}}).catch(err => console.error(err))
    },
    getJsonForSet() {
      if (this.storeState.block.set && this.storeState.block.set.json) {
        let blockId = this.storeState.block.set.json
        this.$router.push({ name: 'Run', params: {id: blockId}}).catch(err => console.error(err))
      } else {
        this.storeState.block.tags.push(this.storeState.setTag)
        let blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        this.storeState.setSourceId = this.storeState.block.uuid
        this.storeState.block.set.json = blockId
        this.storeState.block.set.type = 'sql'
        this.$router.push({ name: 'Run', params: {id: blockId}}).catch(err => console.error(err))
      }
    },
    goToBlockHistory() {
      this.$parent.getSoupFeed({blockId: this.storeState.block.uuid})
      this.$router.push({ name: 'Feed', query: {blockId: this.storeState.block.uuid} }).catch(err => console.error(err))
    },
    goToBlocks() {
      this.$router.push({ name: 'Blocks' }).catch(err => console.error(err))
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
      this.getBlock(this.$route.params.id)
      let self = this
      setTimeout(() => {
        self.$refs.source.focus()
      }, 0);
    },
    clearDestination() {
      this.editDestination = false
      this.$nextTick(() => {
        this.storeState.block.destination = JSON.parse(JSON.stringify(this.storeState.blockTemplate.destination))
        this.searchSheet = null
        this.searchSpreadsheet = null
        this.searchWorkbook = null
        this.searchGdWorkbook = null
        this.storeState.destinations.sheets = []
      })
    },
    sendToSheets() {
      this.showDestination = true
      this.editDestination = true
      this.$nextTick(this.$refs.spreadSheets.focus)
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
    },
    focusSource() {
      this.$nextTick(this.$refs.source.focus)
    },
    focusCm() {
      console.log('focusCm')
      setTimeout(() => {
        if (this.$refs.cm) this.$refs.cm.codemirror.focus()
      }, 100);
    },
    getRepeat(repeat) {
      var ret = false
      if (this.storeState.settings.user.me.trial_expired > 0) {
        ret = 'Trial expired, upgrade to continue scheduling'
        return ret
      } else if (repeat.period === 'hourly') {
        ret = `Hourly at ${repeat.minutesPast} minutes past`
      } else if (repeat.period === 'daily') {
        ret = `Daily at ${repeat.runTime || ' not selected'}`
      } else if (repeat.period === 'weekly') {
        ret = `Weekly on ${repeat.dayOfWeek.replace(/^\w/, c => c.toUpperCase())} at ${repeat.runTime}`
      } else if (repeat.period === 'monthly') {
        ret = `Monthly`
      } else if (repeat.period === 'fivemin') {
        ret = `Every 5 minutes`
      }
      if (this.storeState.block.trigger && this.storeState.block.trigger.blockId && ret) {
        return `${ret} (with trigger)`
      } else if (ret) {
        return ret
      }
      return `Add schedule`
    },
    backToBlocks() {
      this.storeState.searchTerm = ''
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    addSheet() {
      this.storeState.destinations.sheets.push(this.searchSheet)
      this.storeState.block.destination.sheet = this.searchSheet
      setTimeout(() => {
        this.$refs.sheet.blur();
      }, 0);
    },
    addTable() {
      this.getExplore(this)
    },
    addPrimaryKey() {
      
    },
    setParamsFromUrl() {
      if (this.$route.query && Object.keys(this.$route.query).length > 0 && this.storeState.block.params.length > 0) {
        for (let index = 0; index < this.storeState.block.params.length; index++) {
          const p = this.storeState.block.params[index];
          if (this.$route.query[p.name]) {
            console.log('found: ', this.$route.query[p.name])
            this.storeState.block.params[index].value = this.$route.query[p.name]
          }
        }
      }
      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.viewNumber) {
          this.storeState.viewNumber = this.$route.query.viewNumber
        }
        if (this.$route.query.runOnLoad) {
          this.runCode()
        }
        if (this.$route.query.embedDestination) {
          this.embedDestination()
        }
      }
    },
    getBlock(uuid) {
      console.log('getBlock: ', uuid)
      if (uuid === 'new') {
        let blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        store.saveToLocalStorage('seekwell_newBlockId', blockId)
        let routeData = this.$router.push({ name: 'Run', params: {id:  blockId}})
      }
      this.storeState.gotBlock = false
      this.storeState.noAccess = false
      this.storeState.allRows = false
      this.cmOptions.mode = 'text/x-mysql'
      let newBlockId = store.getFromLocalStorage('seekwell_newBlockId')
      if (this.storeState.gotBlocks) {
        this.getBlockHistory(uuid)
        let block = this.storeState.blocks[uuid]
        if (block) {
          console.log('getBlock2: ', block)
          block = store.addMissingBlockAttributes(block)
          this.storeState.block = block
          if (block.destination.sheet && this.storeState.destinations.sheets.length === 0) {
            this.storeState.destinations.sheets.push(block.destination.sheet)
          }
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          } else {
            document.title = 'Untitled'
          }
          if (this.storeState.block.destination.sheetsAppend) {
            this.appendReplace = 'append'
          }
          if (block.cellType === 'snippet') {
            this.storeState.showCm = true
            this.renderSnippet()
            this.showSnippet = true
          }
          if (block.cellType === 'story') {
            if (block.story.json) this.tiptap.setContent(block.story.json)
          } else {
            setTimeout(() => {
              this.focusCm()
            }, 100);
          }
          setTimeout(() => {
            this.storeState.gotBlock = true
            this.setParamsFromUrl()
            if (this.storeState.block.params.length > 0) {
              // this.$parent.useSnippet2(this.storeState.block.uuid)
            }
          }, 100);
        } else if (this.storeState.newBlocks.includes(uuid) || (!uuid || uuid === 'new' || uuid.length === 0)) {
          this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
          this.storeState.block.uuid = uuid
          this.storeState.block.email = this.storeState.settings.user.me.email
          document.title = 'Untitled'
          if (this.storeState.setSourceId) {
            this.storeState.block.source.uuid = this.storeState.setSourceId
            this.storeState.block.set.sql = this.storeState.setSourceId
            this.storeState.block.set.type = 'json'
            this.storeState.block.cellType = 'set'
            this.storeState.block.title = this.storeState.blocks[this.storeState.setSourceId].title + 'Schema'
            this.storeState.block.source = this.storeState.blocks[this.storeState.setSourceId].source
            this.cmOptions.mode = 'javascript'
            this.generateJsonStarterFromHeaders(this.storeState.setSourceId, this.storeState.block.uuid)
            this.storeState.setSourceId = false
            this.focusCm()
          }
          if (this.$route.params.snippet) {
            this.storeState.block.cellType = 'snippet'
            this.renderSnippet()
            this.storeState.showCm = true
            this.showSnippet = true
            this.focusCm()
          }
          if (this.$route.params.cellType === 'story') {
            this.storeState.block.cellType = 'story'
            this.storeState.block.destination.ss_id = false
            this.storeState.block.destination.type = 'email'
          } else if (this.storeState.defaultSource) {
            this.storeState.block.source = this.storeState.defaultSource
            this.focusCm()
          }
          this.storeState.gotBlock = true
        } else {
          // this.storeState.noAccess = true
          // console.log('you dont have access to this block')
        }
      } else if (newBlockId || this.storeState.newBlocks.includes(uuid)) {
        if (newBlockId) {
          console.log('using newBlockId...')
          localStorage.removeItem('seekwell_newBlockId')
          uuid = newBlockId
        }
        
        this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
        this.storeState.block.uuid = uuid
        document.title = 'Untitled'
        this.storeState.newBlocks.push(uuid)
        this.storeState.gotBlock = true
        this.storeState.gettingBlock = false
        if (this.storeState.defaultSource) {
          this.storeState.block.source = this.storeState.defaultSource
        } else {
          let localSource = store.getFromLocalStorage('seekwell_defaultSource')
          if (localSource) {
            this.storeState.allSources = store.getFromLocalStorage('seekwell_allSources')
            this.storeState.block.source = localSource
          }
        }
        this.focusCm()
      // } else if (!this.storeState.gettingBlock) {
      //   this.getOneBlockFromFlask(uuid)
      } else {
        setTimeout(() => {
            this.getBlock(uuid)
        }, 100);
      }
    },
    updateSetSchemaAfterRun() {
      if (this.storeState.block.set && this.storeState.block.set.json && this.storeState.blocks[this.storeState.block.set.json]) {
        let schemaBlockId = this.storeState.block.set.json
        this.generateJsonStarterFromHeaders(this.storeState.block.uuid, schemaBlockId)
        store.updateBlock(this.storeState.blocks[this.storeState.block.set.json])
      } else {
        let block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
        block.uuid = store.uuidv4()
        this.storeState.block.set.json = block.uuid
        this.storeState.newBlocks.push(block.uuid)
        block.source.uuid = this.storeState.setSourceId
        block.set.sql = this.storeState.setSourceId
        block.set.type = 'json'
        block.cellType = 'set'
        block.title = this.storeState.block.title + 'Schema'
        block.source = this.storeState.block.source
        block.tags.push(this.storeState.setTag)
        this.storeState.blocks[block.uuid] = block
        store.updateBlock(block)
        this.generateJsonStarterFromHeaders(this.storeState.block.uuid, block.uuid)
      }
    },
    generateJsonStarterFromHeaders(setSourceId, setBlockId) {
      let value = this.storeState.blocks[setSourceId]
      if (!value) return
      let key = setSourceId
      if (key === setSourceId) {
        var j = {}
        for (let i = 0; i < value.results.headers.length; i++) {
          let el = value.results.headers[i];
          j[el.value] = {
            label: this.makeLabel(el.value),
            type: this.getSetColType(el),
          }
          if (j[el.value].type === 'number') {
            // j[`${el.text}_sum`] = {
            //   "label": `${j[el.value].label} Sum`,
            //   "name": el.text,
            //   "measure": true,
            //   "type": "sum",
            //   "sql": `sum(${el.text})`,
            // }
            j[`${el.text}_raw`] = {
              "label": `${j[el.value].label}`,
              "name": el.text,
              "measure": true,
              "type": "sum",
              "sql": `sum(${el.text})`,
            }
          }
        }
        // j['count'] = {
        //   "label": "Count",
        //   "measure": true,
        //   "type": "count"
        // }
        j = {fields: j, filters: {}}
        j = JSON.stringify(j, null, '\t')
        this.storeState.blocks[setBlockId].code = j
      }
      this.storeState.block.setQueryThings = this.getAllFieldsForSet(setBlockId)
      
    },
    copyBlock() {
      let block = store.makeBlockSafe(this.storeState.block)
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      block.uuid = blockId
      block.title = `${this.storeState.block.title}-copy`
      block.email = this.storeState.settings.user.me.email
      block.editables = {
                pending: {},
                running: {},
            }
      block.favorite = false
      block.form = JSON.parse(JSON.stringify(this.storeState.blockTemplate.form))
      this.storeState.block = block
      this.storeState.blocks[this.storeState.block.uuid] = this.storeState.block
      store.updateBlock({gotBlock: this.storeState.gotBlock})
      this.$router.push({ name: 'Run', params: {id: block.uuid }}).catch(err => console.error(err))
    },
    shareBlock() {
      this.$parent.shareBlock()
    },
    openForm() {
      let hasFormTag = this.storeState.block.tags.filter(t => t.value === 'form')
      if (hasFormTag.length === 0) {
        this.storeState.block.tags.push(this.storeState.formTag)
        store.updateBlock({gotBlock: this.storeState.gotBlock})
      }
      this.storeState.cmdkActive = false
      setTimeout(() => {
        this.$router.push({ name: 'Form', params: {id:  this.storeState.block.uuid}})
      }, 100);
    },
    openSheet() {
      let url = store.getSheetUrl()
      const win = window.open(url, '_blank')
    },
    refreshParamOptions(blockId, index) {
      let block = this.storeState.blocks[blockId]
      store.runTempBlock(block, 
        {
          rowLimit: 10000, 
          updateBlock: true, 
          updateParamOptions: {
            blockId: this.storeState.block.uuid,
            index: index,
          },
        }
      )
    },
    runCode() {
      if (this.storeState.block.set && this.storeState.block.set.type === 'json') {
        let code = store.generateSetSql({test: true})
        store.runSet({code: code})
      } else if (this.storeState.block.cellType != 'story' && this.storeState.block.code.length === 0) {
        this.storeState.snackbar = true;
        this.storeState.message = 'You need to write a query first';
        setTimeout(() => {
          if (this.$refs.cm) this.$refs.cm.codemirror.focus()
        }, 100);
      } else {
        let opts = {pauseDestination: this.pauseDestination}
        store.runCode(opts)
      }
    },
    codeTimerFormat(jsTimeStamp) {
      var ms = (Date.now() - jsTimeStamp);
      var seconds = (ms / 1000);
      var interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return (seconds / 3600).toFixed(1) + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return (seconds / 60).toFixed(1) + "m";
      }
      interval = Math.floor(seconds / 60);
      return (seconds).toFixed(1) + "s";
    },
    cancelRun() {
      clearInterval(this.storeState.codeTimerInterval)
      store.cancelRun({})
    },
    setSchedule() {
      this.showDestination = true;
    },
    updateDestination() {
      this.showDestination = true
    },
    favoriteBlock() {
      this.storeState.block.favorite = !this.storeState.block.favorite
      // this.$refs.title.focus()
      if (this.storeState.block.favorite) {
        setTimeout(() => {
          this.$refs.title.focus()
        }, 0);
      }
    },
    cancelAddSource() {
      this.storeState.addingSource = false
      this.savingSource = false
    },
    addSource() {
      console.log('adding source...')
      this.storeState.addingSource = true
    },
    editSources() {
      console.log('edit source...')
      this.$router.push({ name: 'Sources' }).catch(err => console.error(err))
    },
    sheetsAsSource() {
      console.log('adding source...')
      this.storeState.block.cellType = 'sheetsAsSql'
      // this.storeState.block.source = {
      //   name: 'Sheets',
      //   uuid: 'googlesheets',
      //   type: 'sheets',
      //   meta: false,
      //   spreadsheetId: false,
      //   sheets: [],
      // }
      // this.storeState.allSources.push(this.storeState.block.source)
    },
    saveBlock() {
      store.updateBlock({gotBlock: this.storeState.gotBlock})
      this.$router.push({ name: 'Blocks' }).catch(err => console.error(err))
    },
    validateSource() {
      //all
      if (this.newSource.db_type === 'airtable') {
        this.storeState.block.cellType = 'airtableAsSql'
        if (this.newSource.apiKey) {
          return true
        } else {
          this.$refs.newSourceApiKey.focus()
          return false
        }
      }
      if (this.newSource.db_type === 'bigquery') {
        // this.storeState.block.cellType = 'bigquery'
        if (this.newSource.apiKey) {
          return true
        } else {
          this.$refs.newSourceApiKey.focus()
          return false
        }
      }
      if (!this.newSource.name) {
        this.$refs.newSourceName.focus()
        return false
      }
      if (!this.newSource.username) {
        this.$refs.newSourceUsername.focus()
        return false
      }
      //not snowflake
      if (this.newSource.db_type != 'snowflake' && (!this.newSource.port || isNaN(this.newSource.port))) {
        this.$refs.newSourcePort.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && !this.newSource.host) {
        this.$refs.newSourceHost.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (this.newSource.host.startsWith('https:') || this.newSource.host.startsWith('http:'))) {
        this.$refs.newSourceHost.focus()
        this.connectError = 'Do not include HTTP / HTTPS in the host name'
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (
            this.newSource.ssh) && this.newSource.sshPrivateKey && 
            this.newSource.sshPrivateKey.includes('OPENSSH')) {
        this.$refs.sshPrivateKey.focus()
        this.connectError = `You can't use an OPENSSH private key, use an RSA key instead`
        return false
      }
      //snowflake
      if (this.newSource.db_type === 'snowflake' && !this.newSource.accountName) {
        this.$refs.newSourceAccountName.focus()
        return false
      }
      if (this.newSource.db_type === 'snowflake' && !this.newSource.region) {
        this.$refs.newSourceRegion.focus()
        return false
      }
      return true
    },
    saveSource() {
      let valid = this.validateSource()
      if (!valid) return
      const path = store.getPath('/soup_save_source')
      const d = this.newSource
      d.sessionId = this.storeState.sessionId
      var self = this
      self.savingSource = true
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_save_source: ', res.data)
          self.storeState.block.source.uuid = res.data.block_uuid
          self.testRunSource(self)
        })
        .catch((error) => {
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    timeoutTest(self) {
      if (self.savingSource) {
        self.whitelistError = true
        self.savingSource = false
        self.storeState.snackbar = true;
        self.storeState.message = 'Connection took longer than 15 seconds, check your connection properties and try again';
      }
    },
    testRunSource(self) {
      if (this.newSource.db_type != 'airtable') self.storeState.block.cellType = 'sql'
      let block = store.cleanUpBlock(self.storeState.block);
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
        test: true
      }
      setTimeout(() => {
        self.timeoutTest(self)
      }, 15000);
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('testRunSource: ', res.data)
            self.storeState.addingSource = false
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = 'Source added!';
            self.$parent.getSoupSources()
            setTimeout(() => {
              self.getExplore(self)
            }, 0);
          } else {
            console.error('testRunSource error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true
            let err = res.data.error.replace('<', '')
            self.storeState.message = err
            self.connectError = err
          }
        })
        .catch((error) => {
          console.error('runCode error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    getSfdcMetadata2() {
      this.$parent.getSoupSfdcMetadata({all: true})
    },
    getExplore(self) {
      console.log('getExplore...')
      if (!self.storeState.gotBlock && !self.storeState.gotBlocks) return
      self.storeState.browsing = {
        active: 'schemas', 
        search: '',
        schema: '', 
        table: '',
        column: '',
        stats: {},
        detailsLoading: false,
        results: {},
      }
      if (self.storeState.block.source && !self.storeState.block.source.uuid) return
      if (self.storeState.block.cellType === 'set') return
      let block = JSON.parse(JSON.stringify(self.storeState.block))
      if (self.storeState.allSources.length === 0) return
      let source = self.storeState.allSources.find(s => s.block_uuid === block.source.uuid)
      block.code = self.storeState.exploreSqlDict[source.db_type]
      block.params = []
      block.destination = {}
      block.repeat = {}
      block.limit = 10000
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
        rowLimit: self.storeState.exploreRowLimit,
      }
      setTimeout(() => {
        self.storeState.gettingDbMeta = false
        self.storeState.browsing.detailsLoading = false
      }, 7000);
      self.storeState.dbMeta = false
      self.storeState.gettingDbMeta = true
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          self.storeState.gettingDbMeta = false
          self.storeState.browsing.detailsLoading = false
          if (res.data.ok) {
            console.log('getExplore done: ', res.data)
            self.storeState.snackbar = true;
            self.storeState.message = 'Explore refreshed!';
            self.storeState.dbMeta = res.data
            self.storeState.dbMeta.tables = []
            self.storeState.dbMeta.schemas = []
            self.storeState.dbMeta.schemaTables = []
            let uniqueSchemas = []
            self.storeState.dbMeta.tablesNoViews = []
            if (self.storeState.dbMeta.df.length > 0) self.storeState.browsing.catalog = self.storeState.dbMeta.df[0].table_catalog
            for (let i = 0; i < self.storeState.dbMeta.df.length; i++) {
              let meta = store.lowercaseObjKeys(self.storeState.dbMeta.df[i])
              if (meta.table_schema) {
                var table = `${meta.table_schema}.${meta.table_name}`
              } else {
                var table = `${meta.table_name}`
              }
              if (!self.storeState.dbMeta.tables.includes(table) && meta.table_schema != 'information_schema') {
                self.storeState.dbMeta.tables.push(table)
                self.storeState.dbMeta.schemaTables.push({name: meta.table_name, schema: meta.table_schema, showMore: false})
              }
              if (!uniqueSchemas.includes(meta.table_schema) && meta.table_schema != 'information_schema') {
                self.storeState.dbMeta.schemas.push({name: meta.table_schema, showMore: false})
                uniqueSchemas.push(meta.table_schema)
              }
              if (!self.storeState.dbMeta.tablesNoViews.includes(table) && meta.table_schema != 'information_schema' && meta.is_table>0) {
                self.storeState.dbMeta.tablesNoViews.push(table)
              }
            }
            // self.$parent.getSoupSources()
          } else {
            console.error('getExplore error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = res.data.error;
            self.connectError = res.data.error
            self.storeState.browsing.detailsLoading = false
          }
        })
        .catch((error) => {
          console.error('getExplore error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
          self.storeState.gettingDbMeta = false
          self.storeState.browsing.detailsLoading = false
        })
    },
    changeDestinationType(e, b) {
      console.log(e, b)
    },
    getParams(code) {
      var params = code.match(/{{([^{}]*)}}/g)
      if (!params) {
        return false
      }
      let params2 = []
      let uniqueNames = []
      for (let i = 0; i < params.length; i++) {
        let name = params[i].replace('{{', '').replace('}}', '')
        if (!uniqueNames.includes(name)) {
          // let type = name.startsWith('$') ? 'sheets' : 'basic'
          // let p = {name: name, value: '', type: type}
          var p = this.storeState.block.params.filter(p => p.name === name)
          if (p.name) {
            params2.push(p)
          } else {
            p = {name: name, value: '', type: 'value'}
            params2.push(p)
          }
          uniqueNames.push(name)
        }
      }
      if (params2.length > 0) {
        return params2
      }
      return false
    },
    getIndicesOf(searchStr, str, caseSensitive) {
      var searchStrLen = searchStr.length;
      if (searchStrLen == 0) {
          return [];
      }
      var startIndex = 0, index, indices = [];
      if (!caseSensitive) {
          str = str.toLowerCase();
          searchStr = searchStr.toLowerCase();
      }
      while ((index = str.indexOf(searchStr, startIndex)) > -1) {
          indices.push(index);
          startIndex = index + searchStrLen;
      }
      return indices;
    },
    getTableAliases(tabNames, code) {
      let aliases = {}
      for (let i = 0; i < tabNames.length; i++) {
          let indices = this.getIndicesOf(tabNames[i], code, false)
          if (indices.length > 0) {
              for (let i2 = 0; i2 < indices.length; i2++) {
                  let pos = window.editor.posFromIndex(indices[i2]);
                  var afterTable = window.editor.getRange(pos, {line: pos.line, ch: pos.ch + tabNames[i].length + 100}).split(' ')
                  var afterTableLower = afterTable.map(v => v.toLowerCase());
                  if (afterTable && afterTableLower.includes('as') && (afterTableLower.length > afterTableLower.indexOf('as')+1)) {
                      afterTable = afterTable[afterTableLower.indexOf('as')+1]
                  } else if (afterTable[1]) {
                      afterTable = afterTable[1]
                  }
                  if (afterTable) aliases[afterTable] = tabNames[i]
              }
          }
      }
      return aliases
    },
    getQuerySection(code, editor, cur) { //finds where you are in a query, e.g. SELECT, FROM, WHERE, etc.
      return 'select'
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchTerm = searchTerm.toLowerCase()
      searchIn = searchIn.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var searchInLen = searchIn.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * (startMatch+1)) * 1.0 / searchInLen * 1.0
      return {include: include, matches: matches, ratio: ratio}
    },
    filterBlocks(opts) {
      var blockResults = []
      opts.searchTerm = opts.searchTerm.toLowerCase()
      for (const blockId in this.storeState.blocks) {
        let block = this.storeState.blocks[blockId]
        if (blockId === this.storeState.block.uuid) {
          //pass
        } else if (block.code.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        } else if (block.title.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        }
      }
      blockResults = blockResults.slice(0, opts.numPerCategory)
      return blockResults.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    checkJoinData(join) {
      if (!join.leftTable) return false
      if (!join.leftTable.real_name) return false
      if (!join.leftTable.parent) return false
      if (!join.rightTable) return false
      if (!join.rightTable.real_name) return false
      if (!join.rightTable.parent) return false
      return true
    },
    singleRect(object, bias) {
      const rects = object.getClientRects()
      return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
    },
    textRange(node, from, to) {
      const range = document.createRange()
      range.setEnd(node, to == null ? node.nodeValue.length : to)
      range.setStart(node, from || 0)
      return range
    },
    getCursorCoords(view, pos, end = false) {
      const { node, offset } = view.docView.domFromPos(pos)
      let side
      let rect
      if (node.nodeType === 3) {
        if (end && offset < node.nodeValue.length) {
          rect = this.singleRect(this.textRange(node, offset - 1, offset), -1)
          side = 'right'
        } else if (offset < node.nodeValue.length) {
          rect = this.singleRect(this.textRange(node, offset, offset + 1), -1)
          side = 'left'
        }
      } else if (node.firstChild) {
        if (offset < node.childNodes.length) {
          const child = node.childNodes[offset]
          rect = this.singleRect(child.nodeType === 3 ? this.textRange(child) : child, -1)
          side = 'left'
        }
        if ((!rect || rect.top === rect.bottom) && offset) {
          const child = node.childNodes[offset - 1]
          rect = this.singleRect(child.nodeType === 3 ? this.textRange(child) : child, 1)
          side = 'right'
        }
      } else {
        rect = node.getBoundingClientRect()
        side = 'left'
      }

      const x = rect[side]

      this.suggestionLeft = x + 'px'
      this.suggestionTop = rect.top + window.scrollY + 25 + 'px'
      this.suggestionOverlayLeft = x + 10 + 'px'
      this.suggestionOverlayTop = rect.top + 'px'

      return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x,
      }
    },
    renderStoryHtml(html) {
      try {
        html = html.replace(
          /{([^}]*)}}/g, 
          function (math) {
            var el = document.createElement( 'html' );
            el.innerHTML = math
            return eval(el.textContent);
        });
        this.storeState.mathError = ''
      } catch (error) {
        this.storeState.mathError = error.message
      }
      return html
    },
    getStorySuggestions(opts) {
      const { from, to } = opts.state.selection
      let coords = this.getCursorCoords(this.tiptap.view, from)
      // coordsAtPos(view, pos, end = false)
      this.storeState.showSuggestions = false
      let st = this.storeState.searchTerm.trim()
      let numPerCategory = 3
      this.storeState.compositionSuggestions = []
      for (let [key, block] of Object.entries(this.storeState.blocks)) {
        if (block.results && block.results.headers && block.results.headers.length > 0 && block.title.length > 0) {
          var match = this.everyLetterMatch(st, block.title)
          if (match.include) {
            var h = JSON.stringify(block.results.headers.map(h => h.text)).slice(0, 150)
            h = h.replace('[', '').replace(']', '').replace(/"/g, '')
            var suggestion = {
              title: block.title,
              details: `columns: ${h}`,
              icon: 'mdi-table',
              uuid: store.uuidv4(),
              blockId: key,
              sql: 'sql',
              type: 'block',
              ratio: match.ratio,
            }
            this.storeState.compositionSuggestions.push(suggestion)
          }
          if (block.results.rows.length === 1) {
            for (let i = 0; i < block.results.headers.length; i++) {
              let header = block.results.headers[i];
              var match = this.everyLetterMatch(st, `${block.title}${header.text}`)
              if (match.include) {
                let val = block.results.rows[0][header.text]
                var suggestion = {
                  title: `"${block.title}"."${header.text}"`,
                  path: `${header.text}`,
                  details: `${val}`,
                  value: val,
                  icon: 'mdi-table-column',
                  uuid: store.uuidv4(),
                  blockId: key,
                  type: 'column',
                  ratio: match.ratio,
                }
                this.storeState.compositionSuggestions.push(suggestion)
              }
            }
          }
        }
      }
      this.storeState.showSuggestions = true
      this.storeState.compositionSuggestions = this.storeState.compositionSuggestions.sort((a, b) => { return b.viewedOn - a.viewedOn;})
      this.storeState.compositionSuggestions = this.storeState.compositionSuggestions.slice(0, 50)
    },
    getSuggestions(opts) {
      if (!this.storeState.dbMeta) return
      let trimmedSt = opts.searchTerm.trim()
      let hasDot = opts.beforeSearch === '.' || opts.origSearchTerm === '.'
      if (trimmedSt.length === 0 && !hasDot) {
        this.storeState.searchIndex = -1
        this.storeState.showSuggestions = false
        return
      }
      let numPerCategory = 5
      this.storeState.compositionSuggestions = []
      let lineSplit = opts.line.split(' ')
      let joins = []
      for (let i = 0; i < this.storeState.joinSuggestions.length; i++) {
        let join = this.storeState.joinSuggestions[i];
        var matchLeft = false
        var matchRight = false
        if (join.leftTable && join.leftTable.parent) {
          matchLeft = lineSplit.includes(`${join.leftTable.parent}.${join.leftTable.real_name}`)
        }
        var matchRight = false
        if (join.rightTable && join.rightTable.parent) {
          matchRight = lineSplit.includes(`${join.rightTable.parent}.${join.rightTable.real_name}`)
        }
        if (join.rightTable && matchLeft) { //found the left table in an existing join, should auto add right table from this JOIN
          let match = this.everyLetterMatch(opts.searchTerm, `${join.rightTable.real_name}`)
          if (!match.include) continue
          let alias = store.generateAlias(`${join.rightTable.real_name}`)
          let suggestion = { // add INNER JOIN
            title: `join ${join.rightTable.parent}.${join.rightTable.real_name}`,
            details: `on ${join.right.real_name}`,
            icon: 'mdi-set-center',
            uuid: store.uuidv4(),
            sql: {join: `INNER JOIN\n${join.rightTable.parent}.${join.rightTable.real_name} AS ${alias} ON ${join.left.value} = ${alias}.${join.right.real_name}`},
            type: 'join',
            ratio: match.ratio,
          }
          joins.push(suggestion)
          let suggestion2 = { // add LEFT JOIN
            title: `left join ${join.rightTable.parent}.${join.rightTable.real_name}`,
            details: `on ${join.right.real_name}`,
            icon: 'mdi-set-center',
            uuid: store.uuidv4(),
            sql: {join: `LEFT JOIN\n${join.rightTable.parent}.${join.rightTable.real_name} AS ${alias} ON ${join.left.value} = ${alias}.${join.right.real_name}`},
            type: 'join',
            ratio: match.ratio,
          }
          joins.push(suggestion2)
        }
        if (join.leftTable && matchRight) { //found the right table in an existing join, should auto add left table from this JOIN
          let joinData = this.checkJoinData(join)
          if (!joinData) continue
          let match = this.everyLetterMatch(opts.searchTerm, `${join.leftTable.parent}.${join.leftTable.real_name}`)
          if (!match.include) continue
          let alias = store.generateAlias(`${join.leftTable.real_name}`)
          let suggestion = {
            title: `join ${join.leftTable.parent}.${join.leftTable.real_name}`,
            details: `on ${join.left.real_name}`,
            icon: 'mdi-set-center',
            uuid: store.uuidv4(),
            sql: {join: `INNER JOIN\n${join.leftTable.parent}.${join.leftTable.real_name} AS ${alias} ON ${join.right.value} = ${alias}.${join.left.real_name}`},
            type: 'join',
            ratio: match.ratio,
          }
          joins.push(suggestion)
          let suggestion2 = {
            title: `left join ${join.leftTable.parent}.${join.leftTable.real_name}`,
            details: `on ${join.left.real_name}`,
            icon: 'mdi-set-center',
            uuid: store.uuidv4(),
            sql: {join: `LEFT JOIN\n${join.leftTable.parent}.${join.leftTable.real_name} AS ${alias} ON ${join.right.value} = ${alias}.${join.left.real_name}`},
            type: 'join',
            ratio: match.ratio,
          }
          joins.push(suggestion2)
        }
      }
      if (joins.length > 0) {
        joins.sort((a, b) => { return b.ratio - a.ratio;})
        this.storeState.compositionSuggestions = this.storeState.compositionSuggestions.concat(joins.slice(0, numPerCategory))
      }
      let columns = []
      if (hasDot && this.storeState.block.ast && this.storeState.block.ast.tables) {
        let parentTable = this.storeState.block.ast.tables.find(t => t.alias === opts.beforeDot)
        if (parentTable) {
          if (parentTable.parent) {
            var parentTableName = `${parentTable.parent}.${parentTable.real_name}`
          } else {
            var parentTableName = `${parentTable.real_name}`
          }
        }
        for (let i = 0; i < this.storeState.dbMeta.df.length; i++) {
          let meta = store.lowercaseObjKeys(this.storeState.dbMeta.df[i])
          if (meta.table_schema) {
            var matchName = `${meta.table_schema}.${meta.table_name}`
          } else {
            var matchName = `${meta.table_name}`
          }
          if (matchName === parentTableName) {
            let match = this.everyLetterMatch(opts.searchTerm, meta.column_name)
            if (match.include || opts.searchTerm.length === 0) {
              let suggestion = {
                title: meta.column_name,
                details: `${meta.table_schema}.${meta.table_name}`,
                icon: 'mdi-table-column',
                uuid: `${meta.table_schema}.${meta.table_name}.${meta.column_name}`,
                sql: {table: `${meta.table_schema}.${meta.table_name}`, column: `${meta.column_name}`},
                type: 'column',
                ratio: match.ratio,
              }
              this.storeState.showSuggestions = true
              this.storeState.compositionSuggestions.push(suggestion)
              this.storeState.compositionSuggestions.sort((a, b) => { return b.ratio - a.ratio;})
            }
          }
        }
        if (parentTable) return
      }
      // if (!opts.searchTerm.includes('.')) {
      //   var i = 0
      //   while ((i < this.storeState.dbMeta.df.length) && this.storeState.compositionSuggestions.length < numPerCategory) {
      //     let meta = this.storeState.dbMeta.df[i];
      //     // if (meta.column_name.includes(opts.searchTerm)) { 
      //     let match = this.everyLetterMatch(opts.searchTerm, meta.column_name)
      //     if (match.include) {
      //       let suggestion = {
      //         title: meta.column_name,
      //         details: `in ${meta.table_schema}.${meta.table_name}`,
      //         icon: 'mdi-table-column',
      //         uuid: `${meta.table_schema}.${meta.table_name}.${meta.column_name}`,
      //         sql: {table: `${meta.table_schema}.${meta.table_name}`, column: `${meta.column_name}`},
      //         type: 'column',
      //         ratio: match.ratio,
      //       }
      //       if (match.ratio > 1) {
      //         this.storeState.compositionSuggestions.push(suggestion)
      //       } else {
      //         columns.push(suggestion)
      //       }
      //     }
      //     i++
      //   }
      // }
      // if (this.storeState.compositionSuggestions.length < 5) {
      //   columns.sort((a, b) => { return b.ratio - a.ratio;})
      //   this.storeState.compositionSuggestions = this.storeState.compositionSuggestions.concat(
      //             columns.slice(0, numPerCategory - this.storeState.compositionSuggestions.length))
      // }
      var i = 0
      let tables = []
      while ((i < this.storeState.dbMeta.tables.length) && this.storeState.compositionSuggestions.length < numPerCategory*2) {
        let table = this.storeState.dbMeta.tables[i];
        let match = this.everyLetterMatch(opts.searchTerm, table)
        if (match.include) {
          let suggestion = {
            title: `${table.split('.')[1]}`,
            details: `${table.split('.')[0]}`,
            icon: 'mdi-table',
            uuid: `${table}`,
            sql: {table: `${table}`},
            type: 'table',
            ratio: match.ratio,
          }
          if (match.ratio > 1) {
            this.storeState.compositionSuggestions.push(suggestion)
          } else {
            tables.push(suggestion)
          }
        }
        i++
      }
      if (this.storeState.compositionSuggestions.length < 10) {
        tables.sort((a, b) => { return b.ratio - a.ratio;})
        this.storeState.compositionSuggestions = this.storeState.compositionSuggestions.concat(tables.slice(0, numPerCategory*2 - this.storeState.compositionSuggestions.length))
      }
      // let blockResults = this.filterBlocks({searchTerm: opts.searchTerm, numPerCategory: numPerCategory})
      // for (let i = 0; i < blockResults.length; i++) {
      //   let block = blockResults[i];
      //   let suggestion = {
      //     title: block.title || 'Untitled',
      //     details: `${block.code.replace(/[\n\r]+/g, ' ')}`,
      //     code: block.code,
      //     icon: 'mdi-code-tags',
      //     uuid: block.uuid,
      //     type: 'snippet',
      //   }
      //   this.storeState.compositionSuggestions.push(suggestion)
      // }
      this.storeState.compositionSuggestions.sort((a, b) => { return b.ratio - a.ratio;})
    },
    validateJson(code) {
      var j = {valid: false, j: false}
      try {
        j.j = JSON.parse(code)
        this.jsonParseError = ''
      } catch (error) {
        j.error = error
        this.jsonParseError = error.message
      }
      return j
    },
    onCmReady(cm) {
      console.log('cm ready...')
      var self = this
      let elements = document.getElementsByClassName("cm-parameter");
      Array.from(elements).forEach(function(element) {
        element.addEventListener('click', self.onCmParamClick);
      });
    },
    clearLineErrors() {
      let lineCt = window.editor.lineCount()
      let lineNum = 0
      while (lineNum < lineCt) {
        window.editor.removeLineClass(lineNum, 'background', 'tw-bg-red-200');
        lineNum++
      }
    },
    onCmParamClick(e) {
      console.log('onCmParamClick: ', e)
      if (e.currentTarget.innerText && e.currentTarget.innerText.length > 4) {
        let k = e.currentTarget.innerText.replace('{{', '').replace('}}', '')
        let param = this.storeState.block.params.find(p => p.name === k)
        if (param.type === 'subquery') {
          this.openBlock(param.subqueryId)
        } else if (param.type === 'block') {
          this.openBlock(param.blockId)
        } else {
          this.editParams = true
        }
      }
    },
    onManualCmChange(code) {
      this.storeState.block.manualDestination = code
      this.manualDestinationError = false
      try {
        let j = JSON.parse(code)
      } catch (error) {
        this.manualDestinationError = error.message
      }
    },
    onCmChange(code) {
      var self = this
      let elements = document.getElementsByClassName("cm-parameter");
      Array.from(elements).forEach(function(element) {
        element.addEventListener('click', self.onCmParamClick);
      });
      if (!window.editor) return
      if (this.storeState.errLineNum >= 0) {
        this.clearLineErrors()
      }
      if (this.storeState.returnToZen) {
        this.storeState.returnToZen = false
        this.storeState.viewNumber = 2
      }
      this.storeState.block.code = code
      // if (!this.allowFullCmChangeProcess) return
      // this.allowFullCmChangeProcess = false
      
      setTimeout(() => {
        let params = this.getParams(code)
        let lookup = this.storeState.block.params.filter(p => p.type === 'lookup')
        if (params) {
          // var self = this
          // let elements = document.getElementsByClassName("cm-parameter");
          // Array.from(elements).forEach(function(element) {
          //   element.addEventListener('click', self.onCmParamClick);
          // });
          this.hasParams = true
          for (let i = 0; i < params.length; i++) {
            let p = params[i];
            if (this.storeState.block.params.length > 0) {
              let ex = this.storeState.block.params.find(p2 => p2.name === p.name)
              if (ex) {
                params[i] = ex
              }
            } else {
              this.storeState.block.params = params
              this.editParams = true
            }
          }
          this.storeState.block.params = params
          if (lookup.length > 0) this.storeState.block.params.push(lookup[0])
        } else {
          this.storeState.block.params = []
          this.editParams = false
        }
      }, 1);
      this.renderSnippet()
      if (window.editor.curOp.changeObjs && window.editor.curOp.changeObjs.length > 0) {
        if (window.editor.curOp.changeObjs[0].origin === '+delete') {
          this.storeState.showSuggestions = false
          return
        } else if (window.editor.curOp.changeObjs[0].text && window.editor.curOp.changeObjs[0].text.length > 0) {
          let text = window.editor.curOp.changeObjs[0].text[0]
          if (text.trim() === '') {
            this.storeState.showSuggestions = false
            return
          } else if (!(/^[a-zA-Z]+$/.test(text)) && text != '.') {
            this.storeState.showSuggestions = false
            return
          }
        }
      }
      let cur = editor.getCursor()
      this.storeState.lastCur = cur
      let line = editor.getRange({line : cur.line, ch : 0}, {line : cur.line, ch : cur.ch})
      this.storeState.endOfLine = editor.getLine(cur.line).length === cur.ch
      // let requestColVals = (line.slice(cur.ch - 3, cur.ch) == "= '" && this.getCellType() == 'sql')
      let wordRange = editor.findWordAt(cur);
      this.origSearchTerm = editor.getRange(wordRange.anchor, wordRange.head)
      if (this.storeState.block.cellType === 'json') {
        let j = this.validateJson(code)
        return
      }
      if (this.origSearchTerm == ' ') {
        cur = {line: cur.line, ch: cur.ch-1, sticky: null}
        wordRange = editor.findWordAt(cur);
        this.origSearchTerm = editor.getRange(wordRange.anchor, wordRange.head)
      }
      this.storeState.searchTerm = this.origSearchTerm.replace(/[^a-zA-Z ]/g, "")
      this.beforeSearch = editor.getRange({line: wordRange.anchor.line, ch: wordRange.anchor.ch-1}, wordRange.anchor)
      if (this.storeState.searchTerm.length == 0 && cur.ch > 0 && this.origSearchTerm != '.') {
        wordRange = editor.findWordAt(({line : cur.line, ch : cur.ch - 1}, {line : cur.line, ch : cur.ch-1}));
        var searchTerm = editor.getRange(wordRange.anchor, wordRange.head)
        this.storeState.searchTerm = this.storeState.searchTerm.replace(/[^a-zA-Z ]/g, "")
        this.beforeSearch = editor.getRange({line: wordRange.anchor.line, ch: wordRange.anchor.ch-1}, wordRange.anchor)
      }
      let querySection = this.getQuerySection(code, editor, cur)
      this.storeState.compositionSuggestions = []
      let i = 0
      var beforeDot = ''
      if (this.beforeSearch == '.' || this.origSearchTerm == '.') {
        var goBack = 1
        if (this.beforeSearch == '.') goBack = 2
        var beforeDot = window.editor.findWordAt({line: wordRange.anchor.line, ch: wordRange.anchor.ch-goBack}, wordRange.anchor)
        beforeDot = window.editor.getRange(beforeDot.anchor, beforeDot.head)
      }
      this.getSuggestions(
        {
          searchTerm: this.storeState.searchTerm, 
          beforeSearch: this.beforeSearch, 
          beforeDot: beforeDot,
          line: line,
          origSearchTerm: this.origSearchTerm,
        }
        )
      let hasDot = this.beforeSearch != '.' || this.origSearchTerm != '.'
      var coords = editor.cursorCoords(true);
      this.suggestionLeft = coords.left + 'px'
      this.suggestionTop = coords.top + 25 + 'px'
      this.suggestionOverlayLeft = coords.left + 10 + 'px'
      this.suggestionOverlayTop = coords.top + 'px'
      if (this.storeState.compositionSuggestions.length > 0 && (this.storeState.searchTerm.length > 0 || hasDot)) {
        this.storeState.showSuggestions = true
      } else {
        this.storeState.showSuggestions = false
      }
      this.storeState.searchIndex = 0
    },
    onCmFocus() {
      var self = this
      let elements = document.getElementsByClassName("cm-parameter");
      Array.from(elements).forEach(function(element) {
        element.addEventListener('click', self.onCmParamClick);
      });
      this.storeState.blockListOpen = false
      window.editor = this.$refs.cm.codemirror
      this.storeState.tableExpanded = false
      this.storeState.currentFocus = 'code'
      if (this.storeState.returnToZen) {
        this.storeState.returnToZen = false
        this.storeState.viewNumber = 2
      }
      this.storeState.cssProps['--cm-line-number-color'] = 'rgba(0, 0, 0, 0.25)'
      this.storeState.cssProps['--cm-gutter-display'] = 'unset'
      
    },
    onCmBlur() {
      this.storeState.currentFocus = 'main'
      this.storeState.cssProps['--cm-line-number-color'] = '#fff'
      // this.storeState.cssProps['--cm-gutter-display'] = 'none'
    },
    onSpreadSheetChange(newVal) {
      console.log('onSpreadSheetChange', newVal)
      this.storeState.destinations.sheets = []
      this.loadingSheets = true
      this.getSheets()
    },
    onSpreadSheetChangeSource(newVal) {
      console.log('onSpreadSheetChange', newVal)
      this.storeState.block.source.sheets = []
      this.getSheetsSource()
    },
    getSheetsSource() {
      const path = store.getPath('/soup_get_sheets')
      let d = {sessionId: this.storeState.sessionId, ss_id: this.storeState.block.source.spreadsheetId}
      var self = this
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_get_sheets: ', res.data)
          if (!res.data.sheets) {
            this.storeState.snackbar = true;
            this.storeState.message = 'Error getting Sheets metadata';
            return
          }
          self.loadingSheets = false
          self.storeState.block.source.sheets = res.data.sheets.map(s => s.properties.title)
          self.$forceUpdate()
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSheets() {
      const path = store.getPath('/soup_get_sheets')
      let d = {sessionId: this.storeState.sessionId, ss_id: this.storeState.block.destination.ss_id}
      var self = this
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_get_sheets: ', res.data)
          if (!res.data.sheets) {
            this.storeState.snackbar = true;
            this.storeState.message = 'Error getting Sheets metadata';
            return
          }
          self.loadingSheets = false
          self.storeState.destinations.spreadSheetMetadata = res.data
          self.storeState.destinations.sheets = res.data.sheets.map(s => s.properties.title)
          self.$forceUpdate()
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    moment: function () {
      return moment();
    },
    getTags() {
      console.log('val term: ', this.newTag)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  beforeCreate() {
    
  },
  created() {
    window.addEventListener("message", (event) => {
      // console.log('event...', event)
      if (event.data && event.data.sender === 'tse') {
        this.fromTse = event.data.data
      }
    }, false);
    window.parent.postMessage(
        {
            sender: "seekwell",
            data: {loaded: true}
        },
        "*"
    )
    this.storeState.createdRunAt = moment.unix(moment()).utc()._i
    store.updateBlock = debounce(store.updateBlock, 150)
    // this.onCmChange = debounce(this.onCmChange, 50)
    this.getBlock(this.$route.params.id)
    this.storeState.allRows = false
    window.bus.$on('focusRef',(details) => {
      console.log('focusRef.....', details)
      var ref = this.$refs[details.ref]
      if (ref && ref[0]) ref[0].focus()
    });
  },
};
</script>

<style>
.active {
  background-color: #eee;
}
.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.container {
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 20px;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.sub-title {
  font-size: 16px;
  padding-top: 0px;
}
.timeline-container {
  padding-top: 30px;
  padding-bottom: 10px;
}
.details-card {
  padding-left: 30px;
  padding-right: 30px;
}
.tag {
  margin-left: 0px;
}
.tag2 {
  margin-left: 15px;
}
.comment-text {
  color: rgba(0, 0, 0, 0.87);
}
.comment-title {
  font-size: 14px;
  font-weight: 700;
}
.comment-time {
  font-size: 12px;
  color: rgba(55, 53, 47, 0.4);
  font-weight: normal;
}
.card-head {
  font-size: 24px;
  font-weight: 700;
}
.reminder {
  color: rgb(46, 170, 220);
  cursor: pointer;
}
.clock {
  margin-bottom: 2px;
}
.reminder-text {
  margin-left: 5px;
}
.create-tag {
  margin-left: 15px;
}
.block-container {
  position: relative;
  min-height: 360px;
  border-radius: 5px;
  padding-top: 20px;
  padding-left: 2rem;
  padding-right: 2rem;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 16px 45px rgba(0, 0, 0, 0.05), 0 0 0.5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition-property: box-shadow;
  transition-duration: 0.4s;
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition-delay: 0s;
}
.block-footer {
  position: absolute;
  bottom: 0;
  padding-bottom: 15px;
  padding-right: 60px;
  width: 100%;
}
.CodeMirror {
  height: 100%;
  width: 100%;
}
.v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner {
  display: none;
}
.table-container {
  /* margin-top: 60px; */
  /* z-index: 9999;
  position: absolute;
  width: 100%;
  top: 60vh; */
  -webkit-transition: all .25s;
  -moz-transition: all .25s;
  -o-transition: all .25s;
  transition: all .5s ease;
  padding-bottom: 5rem;
}
.hide {
  display: none;
}
.auto-prepend-label {
  /* padding-bottom: 8px; */
  font-weight: 700;
}
div.block-container > div:nth-child(2) > 
  div.col-sm-2.col-md-2.col-12 > div > div > 
  div.v-input__slot > div.v-select__slot > div.v-select__selections {
  padding-left: 0px !important;
}
.denser {
  padding-top: 0px !important;
  margin-top: 0px !important;
  margin: 0 !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  max-height: 40px;
  padding-left: 0px !important;
}
.v-input--selection-controls__input {
  transform: scale(.85);
  transform-origin: left;
}
.v-label {
  padding-top: 0px !important;
  margin-top: 0px !important;
  margin: 0 !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.v-select__selection--comma {
  margin: 0 !important;
  margin-left: 4px !important;
}
.v-text-field input {
  padding: 0px;
}
.CodeMirror pre.CodeMirror-placeholder { 
  color: #999; 
}
.soup-btn {
  outline: none !important;
}
.vue-codemirror {
  padding-top: 0px !important;
}
.tooltip-text {
  font-weight: 700;
  margin-right: 10px;
}
.right {
  float: right;
}
.pad-btn {
  padding-left: 20px;
}
.pad-col-left {
  padding-left: 20px !important;
}
.pad-col-right {
  padding-right: 30px !important;
}
.title-container {
  padding-bottom: 30px;
  padding-right: 2px;
  padding-left: 2px;

}
.title {
  font-size: 24px;
  font-weight: 700;
  padding-right: 10px;
}
.title-history {
  color: rgba(0, 0, 0, 0.25);
  padding-left: 0px;
  width: 100px;
  cursor: pointer;
  /* display: inline-block; */
}
.back {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 30px;
  margin-top: 22px;
}
.block-detail-row {
  min-height: 40px;
}
.v-input__slot {
  margin: 0 !important;
}
.time-separator {
  font-weight: 700;
  font-size: 20px;
}
.nosource-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  height: 200px;
}
.nosource {
  align-self: center;
  padding-top: 30px;
}
.btn-link {
  color:rgb(46, 170, 220);
  font-weight: 700;
}
.source-input {

}
.source-input > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: .5rem;
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot > input {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 2px;
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding-left: 3px !important;
}
/* .v-text-field--outlined .v-label--active {
  margin-left: -16px !important;
  margin-top: -3px !important;
} */
.v-text-field--outlined .v-label--active {
  -webkit-transform: translateY(-24px) scale(0.75);
  transform: translateY(-27px) translateX(-6px) scale(0.75);
}
.v-input .v-label {
  height: 26px;
  padding-left: 3px;
}
.source-input > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
  padding-top: 5px;
  padding-bottom: 15px;
  padding-left: 0px;
}
.block-detail-row > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
  padding-top: 5px;
  padding-bottom: 15px;
  padding-left: 0px;
}
.v-input--checkbox {
  margin: 0px !important;
  padding-top: 0px !important;
}
.connect-error {
  margin-left: 35px;
  margin-right: 30px;
}
.error--text {
  color: #eb5757 !important;
}
.send-to-sheets {
  float: right;
  color: rgb(46, 170, 220);
  font-weight: 700;
  padding-top: 20px;
  cursor: pointer;
}
.run-icon {
  margin-top: -2px;
  margin-left: 0px;
}
.dest-type-label {
  padding-left: 5px;
}
.dest-type-icon {
  margin-top: -2px !important;
}
.destination-type {

}
.destination-type > .v-icon {
  margin-top: -2px !important;
}
.run-meta {
  float: right;
  color:rgba(0, 0, 0, 0.5);
  padding-top: 20px;
  font-size: 13px;
  padding-right: 0px;
}
.run-container {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 30px;
}
@media screen and (min-width: 700px) {
  .run-container {
    padding-left: 100px;
    padding-right: 100px;
    padding-top: 30px;
  }
}
@media screen and (min-width: 1200px) {
  .run-container {
    padding-left: 6rem;
    padding-right: 6rem;
    padding-top: 30px;
  }
}
.history-row-title {
  font-weight: 700;
}
.history-row {
  min-width: 480px;
}
.history-row-meta {
  float: right;
  color:rgba(0, 0, 0, 0.5);
}
.pad-span-left {
  padding-left: 15px;
}
.cm-bracket-sw {
  font-weight: 700;
  font-weight: 700;
  /* color: rgb(46, 170, 220); */
  /* cursor: pointer; */
  background-color: #0055aac2;
  padding-top: 2px;
  padding-bottom: 2px;
  color: white;
  border-radius: 5px;
}
.col-no-pad {
  padding-top: 0px;
  padding-bottom: 0px;
}
.history-list {
  margin-top: 0px;
  padding-top: 0px;
}
.composition-suggestions-container {
  max-width: 100%;
  min-width: 600px;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  z-index: 11;
  max-height: 400px;
  overflow: scroll;
}
.composition-suggestion-overlay {
  position: absolute;
  color: #999;
  background-color: #fff;
  z-index: 2;
}
.composition-suggestion-row {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 5px;
  padding-right: 5px;
  /* border-left-color: #fff;
  border-left-style: solid;
  border-left-width: 3px; */
  border-radius: 2px;
}
.suggestion-col {
  padding-top: 5px;
  padding-bottom: 5px;
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestion-row-hover:hover {
  background-color: #eee;
  /* border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px; */
}
.suggestion-row-active {
  background-color: #eee;
}
.small-chart {
  /* max-width: 600px; */
  max-height: 600px;
  margin-left: 2em;
  margin-top: 1em;
}
.pad-top5 {
  padding-top: 5px !important;
}
.v-select__selections {
  padding-left: 0px !important;
}
</style>
